export default {
  "nav_signin": "Anmelden",
  "nav_account": "Konto",
  "nav_signout": "Abmelden",
  "hero_title": "Smarte Digitallösungen",
  "hero_title_line1": "Infinity Business — Smarte",
  "hero_title_line2": "Digitallösungen",
  "hero_subtitle": "Lernen Sie RisTA kennen – Ihren digitalen Partner",
  "hero_cta": "Mit RisTA sprechen",
  "hero_cta2": "Unsere Leistungen",
  "b2b_title": "Geschäftslösungen (B2B)",
  "p2p_title": "Persönliche Lösungen (P2P)",
  "b2b_desc": "Web, Mobile, Software, Hosting, Design und Werbung",
  "p2p_desc": "Krypto-Bildung, Investment-Tools, Organisation, Übersetzung, Branding, Domains",
  "services_title": "Unsere Dienste",
  "services_subtitle": "Von Unternehmenslösungen bis hin zu persönlichen Investment-Tools – RisTA zeigt Ihnen den Weg.",
  "cta_title": "Bereit, etwas Großartiges zu schaffen?",
  "cta_subtitle": "Lassen Sie sich von RisTA in wenigen Minuten ein maßgeschneidertes Angebot erstellen.",
  "about": "Über uns",
  "contact": "Kontakt",
  "privacy": "Datenschutz",
  "blog": "Blog",
  "donate": "Spenden",
  "booking": "Termin buchen",
  "login_title": "Willkommen zurück",
  "register_title": "Konto erstellen",
  "login_subtitle": "Melden Sie sich bei Ihrem Infinity Business Konto an",
  "register_subtitle": "Werden Sie Teil von Infinity Business",
  "auth0_btn": "Weiter mit Auth0",
  "or_email": "oder per E-Mail anmelden",
  "email": "E-Mail-Adresse",
  "password": "Passwort",
  "full_name": "Vollständiger Name",
  "signin_btn": "Anmelden",
  "register_btn": "Konto erstellen",
  "no_account": "Noch kein Konto?",
  "have_account": "Bereits ein Konto?",
  "create_one": "Erstellen",
  "sign_in": "Anmelden",
  "pricing_title": "Wählen Sie Ihren Plan",
  "pricing_subtitle": "Alle Pläne beinhalten Zugang zu RisTA.",
  "pay_stripe": "Mit Stripe bezahlen",
  "pay_mypos": "Mit myPOS bezahlen",
  "pay_crypto": "Mit Krypto bezahlen",
  "free_plan": "Aktueller Gratisplan",
  "most_popular": "Am beliebtesten",
  "dashboard_title": "Mein Konto",
  "profile": "Profil",
  "security": "Sicherheit (2FA)",
  "subscription": "Abonnement",
  "upgrade": "Upgrade",
  "change_plan": "Plan ändern",
  "twofa_title": "Zwei-Faktor-Authentifizierung",
  "setup_2fa": "2FA einrichten",
  "disable_2fa": "2FA deaktivieren",
  "payment_success": "Zahlung erfolgreich!",
  "payment_cancel": "Zahlung abgebrochen",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Alle Rechte vorbehalten.",
  "about_title": "Über Infinity Business",
  "contact_title": "Kontaktieren Sie uns",
  "privacy_title": "Datenschutzrichtlinie",
  "send_message": "Nachricht senden",
  "trade_title": "Wir handeln für Sie",
  "trade_desc": "Professionelle Krypto-Handelsdienste. Chatten Sie mit uns.",
  "back_home": "Zurück zur Startseite",
  "loading": "Laden...",
  "save": "Speichern",
  "session_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "nav_services": "Dienste",
  "nav_portal": "Portal",
  "nav_credits": "Guthaben",
  "hero_online": "Online",
  "hero_digital_partner": "Digitaler Partner",
  "business_solutions": "Geschäftslösungen",
  "personal_solutions": "Persönliche Lösungen",
  "enterprise_desc": "Professionelle digitale Lösungen für Ihr Unternehmen.",
  "personal_desc": "Smarte Investment-Tools und Bildungsangebote für persönliches Wachstum.",
  "services_hero_title": "Unsere Dienste",
  "services_hero_desc": "Von einfachen Websites bis hin zu leistungsstarken KI-Lösungen – wir liefern digitale Exzellenz nach Maß.",
  "get_started": "Jetzt starten",
  "get_a_quote": "Angebot erhalten",
  "free_seo_audit": "Kostenloser SEO-Audit",
  "ready_to_start": "Bereit zu starten?",
  "ready_to_build": "Bereit, etwas Großartiges zu schaffen?",
  "ready_to_build_sub": "Sprechen Sie mit RisTA für ein individuelles Angebot.",
  "trusted_worldwide": "Weltweit im Einsatz",
  "chat_placeholder": "Nachricht eingeben...",
  "chat_suggested_1": "Ich brauche eine Website",
  "chat_suggested_2": "Erzählen Sie mir von den Diensten",
  "chat_suggested_3": "Ich möchte einen KI-Dienst",
  "chat_suggested_4": "Kostenvoranschlag erhalten",
  "trust_platform": "Vertrauenswürdige Plattform",
  "trust_security": "Unternehmenssicherheit",
  "trust_ai": "KI-gestützt",
  "trust_global": "Globale Reichweite",
  "back_to_home": "Zurück zur Startseite",
  "continue_google": "Weiter mit Google",
  "continue_facebook": "Weiter mit Facebook",
  "continue_github": "Weiter mit GitHub",
  "or_continue_email": "oder mit E-Mail fortfahren",
  "two_factor_auth": "Zwei-Faktor-Authentifizierung",
  "enter_2fa_code": "Geben Sie den Code aus Ihrer Authenticator-App ein",
  "verify_btn": "Code bestätigen",
  "verifying": "Überprüfung...",
  "use_different_account": "Anderes Konto verwenden",
  "session_expired_msg": "Ihre Sitzung ist wegen Inaktivität abgelaufen. Bitte melden Sie sich erneut an.",
  "nav_home": "Startseite",
  "nav_back": "Zurück",
  "my_account": "Mein Konto",
  "sign_out": "Abmelden",
  "client_portal": "Kundenportal",
  "your_projects": "Ihre Projekte",
  "your_invoices": "Ihre Rechnungen",
  "projects": "Projekte",
  "invoices_tab": "Rechnungen",
  "milestones": "Meilensteine",
  "messages": "Nachrichten",
  "no_projects": "Noch keine Projekte. Ihre Projekte erscheinen hier, sobald sie erstellt werden.",
  "no_invoices": "Noch keine Rechnungen.",
  "no_messages": "Noch keine Nachrichten. Beginnen Sie eine Konversation mit dem Team.",
  "type_message": "Nachricht eingeben...",
  "back_to_projects": "Zurück zu Projekten",
  "budget_label": "Budget",
  "progress_label": "Fortschritt",
  "service_label": "Dienstleistung",
  "portal_locked_desc": "Das Kundenportal steht zugelassenen Kunden zur Verfügung.",
  "contact_to_start": "Kontaktieren Sie uns",
  "quick_web_dev": "Webentwicklung",
  "quick_mobile": "Mobile App",
  "quick_crypto": "Krypto-Bildung",
  "quick_get_quote": "Angebot einholen",
  "quick_tell_more": "Erzählen Sie mehr",
  "quick_have_project": "Ich habe ein Projekt",
  "quick_submit": "Anfrage senden",
  "get_cost_estimate": "Kostenschätzung",
  "choose_plan": "Wählen Sie Ihren Plan",
  "choose_plan_desc": "Skalieren Sie Ihr Unternehmen mit dem richtigen Plan.",
  "current_free_plan": "Aktueller kostenloser Plan",
  "svc_ecommerce_label": "E-Commerce / Webshop",
  "svc_ecommerce_desc": "Komplette Online-Shops mit Zahlungsintegration",
  "svc_seo_label": "SEO & Digitales Marketing",
  "svc_seo_desc": "Suchmaschinenoptimierung und Wachstumsstrategie",
  "svc_hosting_label": "Managed Hosting",
  "svc_hosting_desc": "Sichere, schnelle und zuverlässige Hosting-Infrastruktur",
  "svc_advertising_label": "Digitale Werbung",
  "svc_advertising_desc": "PPC, Social Ads und Performance Marketing",
  "svc_trading_label": "Handelsberatung",
  "svc_trading_desc": "Expertengeführte Handelsstrategiesitzungen",
  "svc_domains_label": "Domain-Verwaltung",
  "svc_domains_desc": "Domain-Registrierung, DNS-Verwaltung und Transfers",
  "svc_ecommerce_price": "Ab €799",
  "svc_seo_price": "Ab €299/Monat",
  "svc_hosting_price": "Ab €29/Monat",
  "svc_advertising_price": "Ab €499/Monat",
  "svc_trading_price": "Ab €149/Sitzung",
  "svc_domains_price": "Ab €19/Jahr",
  "testimonials_title": "Was unsere Kunden sagen",
  "testimonials_subtitle": "Geschätzt von Unternehmen in ganz Europa",
  "stat_projects": "Projekte abgeschlossen",
  "stat_satisfaction": "Kundenzufriedenheit",
  "stat_languages": "Unterstützte Sprachen",
  "all_rights_reserved": "Alle Rechte vorbehalten.",
  "form_your_name": "Ihr Name",
  "form_your_email": "Ihre E-Mail",
  "form_describe_need": "Beschreiben Sie, was Sie brauchen...",
  "form_additional_feedback": "Zusätzliches Feedback? (optional)",
  "form_email_followup": "Ihre E-Mail (optional, für Rückmeldung)",
  "form_budget_range": "Budgetrahmen",
  "form_timeline": "Zeitrahmen",
  "form_cancel": "Abbrechen",
  "form_select_services": "Dienste auswählen (mehrere möglich):",
  "rating_title": "Bewerten Sie Ihre Erfahrung mit RisTA",
  "rating_helpful": "Wie hilfreich war dieses Gespräch?",
  "rating_overall": "Gesamterfahrung mit dem Assistenten",
  "rating_recommend": "Würden Sie RisTA empfehlen?",
  "rating_yes": "Ja",
  "rating_no": "Nein",
  "rating_submit": "Bewertung abgeben",
  "rating_skip": "Überspringen",
  "rating_thanks": "Vielen Dank für Ihr Feedback!",
  "generating_estimate": "Kostenvoranschlag wird erstellt...",
  "profile_info": "Profilinformationen",
  "profile_name": "Name",
  "profile_email": "E-Mail",
  "profile_role": "Rolle",
  "profile_member_since": "Mitglied seit",
  "profile_rerun_onboarding": "Onboarding erneut starten",
  "profile_language_pref": "Bevorzugte Sprache",
  "profile_language_saved": "Spracheinstellung gespeichert!",
  "privacy_heading": "Datenschutzerklärung",
  "terms_heading": "Allgemeine Geschäftsbedingungen",
  "about_heading": "Über Infinity Business",
  "walkthrough_heading": "Anleitungen",
  "nav_tools": "Werkzeuge",
  "nav_marketplace": "Marktplatz",
  "chat_digital_partner": "Digitaler Partner",
  "chat_online": "Online",
  "chat_help_text": "Ich helfe bei Webentwicklung, mobilen Apps, Design, Krypto und vielem mehr.",
  "chat_your_partner": "Ihr digitaler Partner",
  "chat_assistant_subtitle": "Chatten Sie mit Ihrem KI-Assistenten",
  "tab_password": "Passwort",
  "tab_rista_services": "RisTA-Dienste",
  "tab_analytics": "Analysen",
  "tab_projects": "Projekte",
  "tab_referral": "Empfehlungsprogramm",
  "marketplace_title": "Vorlagen-Marktplatz",
  "marketplace_subtitle": "Premium-Vorlagen zum Anpassen – professionelle Qualität, sofort einsatzbereit.",
  "marketplace_search": "Vorlagen durchsuchen...",
  "marketplace_purchase": "Kaufen",
  "marketplace_preview": "Vorschau",
  "marketplace_all": "Alle",
  "marketplace_category_website": "Website",
  "marketplace_category_brand": "Marke",
  "marketplace_category_resume": "Lebenslauf",
  "marketplace_downloads": "Downloads",
  "marketplace_close_preview": "Vorschau schließen",
  "marketplace_features": "Funktionen",
  "marketplace_live_preview": "Live-Vorschau",
  "case_studies_title": "Kundenerfolgsgeschichten",
  "case_studies_subtitle": "Echte Ergebnisse echter Unternehmen. Erleben Sie die Transformation.",
  "case_studies_before": "Vorher",
  "case_studies_after": "Nachher",
  "case_studies_cta_title": "Bereit, Ihr Unternehmen voranzubringen?",
  "case_studies_cta_desc": "Schließen Sie sich diesen Unternehmen an und erzielen Sie ähnliche Ergebnisse mit unseren KI-gestützten Diensten.",
  "case_studies_cta_btn": "Jetzt starten",
  "profile_go_homepage": "Zur Startseite",
  "onboarding_welcome_title": "Willkommen bei Infinity Business",
  "onboarding_welcome_subtitle": "Ihr KI-gestützter digitaler Partner",
  "onboarding_welcome_content": "Infinity Business bietet umfassende B2B- und P2P-Digitaldienste. Unser KI-Assistent RisTA begleitet Sie auf dem gesamten Weg.",
  "onboarding_welcome_item1": "KI-gestützte Projektschätzung und über 20 Mikro-Tools",
  "onboarding_welcome_item2": "Web-, Mobil- und Designdienste",
  "onboarding_welcome_item3": "Krypto-Bildung & Investitionstools",
  "onboarding_welcome_item4": "Persönliche Beratungen",
  "onboarding_services_title": "Unsere Dienste entdecken",
  "onboarding_services_subtitle": "Zwei Kategorien für Ihre Bedürfnisse",
  "onboarding_services_content": "Wir bieten zwei Kategorien von Diensten an:",
  "onboarding_services_item1": "B2B: Webentwicklung, Mobile Apps, Grafikdesign, Hosting, Software, Werbung",
  "onboarding_services_item2": "P2P: Krypto-Bildung, Investitionstools, Trading, Domains, DeFi",
  "onboarding_services_item3": "KI-Dienste: Lebenslauf, Businessplan, SEO-Berichte, Markenpakete u. v. m.",
  "onboarding_services_item4": "Sprechen Sie jederzeit mit RisTA für ein individuelles Angebot",
  "onboarding_credits_title": "Guthabensystem",
  "onboarding_credits_subtitle": "Prepaid-Guthaben für KI-Dienste",
  "onboarding_credits_content": "Nutzen Sie Guthaben für den sofortigen Zugang zu unseren KI-Diensten:",
  "onboarding_credits_item1": "Laden Sie Ihr Guthaben jederzeit auf (min. 5, max. 1.000)",
  "onboarding_credits_item2": "Guthaben wird bei Nutzung von KI-Diensten automatisch abgezogen",
  "onboarding_credits_item3": "Sie werden immer vor einer Abbuchung gefragt",
  "onboarding_credits_item4": "Sehen Sie Ihren Kontostand und Verlauf im Guthaben-Panel",
  "onboarding_chat_title": "Mit RisTA sprechen",
  "onboarding_chat_subtitle": "Ihr digitaler Partner ist bereit",
  "onboarding_chat_content": "RisTA unterstützt Sie bei:",
  "onboarding_chat_item1": "Projektschätzungen und Angebote erhalten",
  "onboarding_chat_item2": "Serviceoptionen im Detail erkunden",
  "onboarding_chat_item3": "Serviceanfragen einreichen",
  "onboarding_chat_item4": "Fragen in 11 Sprachen beantworten",
  "onboarding_next": "Weiter",
  "onboarding_get_started": "Loslegen",
  "onboarding_back": "Zurück",
  "onboarding_biz_title": "Diensteauswahl",
  "onboarding_biz_subtitle": "Was beschreibt Ihre Bedürfnisse am besten?",
  "onboarding_biz_content": "Helfen Sie uns, die richtigen Dienste für Sie zu empfehlen:",
  "onboarding_biz_type_startup": "Startup / Neues Unternehmen",
  "onboarding_biz_type_smb": "Kleines-Mittleres Unternehmen",
  "onboarding_biz_type_enterprise": "Großunternehmen / Konzern",
  "onboarding_biz_type_freelancer": "Freiberufler / Einzelperson",
  "onboarding_biz_type_investor": "Investor / Krypto-Enthusiast",
  "change_password_title": "Passwort ändern",
  "change_password_current": "Aktuelles Passwort",
  "change_password_new": "Neues Passwort",
  "change_password_confirm": "Neues Passwort bestätigen",
  "change_password_btn": "Passwort ändern",
  "referral_title": "Empfehlungsprogramm",
  "referral_generate": "Meinen Empfehlungscode generieren",
  "referral_redeem_title": "Code einlösen",
  "referral_redeem_btn": "Einlösen",
  "referral_referrals": "Empfehlungen",
  "referral_rewards": "Belohnungen",
  "referral_copy_link": "Link kopieren",
  "referral_copied": "Kopiert!",
  "project_tracker_title": "Projektverfolgung",
  "project_no_projects": "Noch keine Projekte. Projekte erscheinen hier nach dem Kauf eines Dienstes.",
  "analytics_total_services": "Dienste gesamt",
  "analytics_completed": "Abgeschlossen",
  "analytics_pending": "Ausstehend",
  "analytics_total_spent": "Gesamtausgaben",
  "analytics_credit_balance": "Guthabenstand",
  "analytics_recent": "Letzte Dienste",
  "billing_management": "Abrechnungsverwaltung",
  "billing_manage_btn": "Abrechnung verwalten",
  "billing_cancel_btn": "Plan kündigen",
  "plan_features": "Ihre Planfunktionen",
  "nav_try_free": "Kostenlos testen",
  "profile_appearance": "Erscheinungsbild & Barrierefreiheit",
  "profile_theme": "Design",
  "profile_text_size": "Textgröße",
  "profile_text_size_hint": "Passen Sie die Textgröße für leichteres Lesen an.",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_1_text": "RisTA hat uns geholfen, unsere gesamte Webpräsenz in nur 2 Wochen aufzubauen. Die KI-gestützte Beratung hat unsere Anforderungen punktgenau erfasst.",
  "testimonial_2_role": "Marketingleiterin, BioFresh",
  "testimonial_2_text": "Das Marken-Kit und der Social-Media-Kalender haben uns Monate an Arbeit gespart. Die Qualität übertraf das, was wir von traditionellen Agenturen bekamen.",
  "testimonial_3_role": "Freiberuflicher Entwickler",
  "testimonial_3_text": "Ich nutze den Lebenslauf-Builder und die Konkurrenzanalyse-Tools regelmäßig. Die KI-generierten Ergebnisse sind sofort einsatzbereit, und das Guthabensystem sorgt für transparente Preise.",
  "services_cta_title": "Bereit zu starten?",
  "services_cta_desc": "Sprechen Sie mit RisTA, unserem KI-gestützten Digitalassistenten, und erhalten Sie ein maßgeschneidertes Angebot.",
  "services_talk_rista": "Mit RisTA sprechen",
  "services_free_audit": "Kostenloser SEO-Audit",
  "tools_title": "Kostenlose Marketing-Tools",
  "tools_subtitle": "Probieren Sie unsere kostenlosen Tools aus – ganz ohne Anmeldung",
  "sp_basic_web_name": "Einfache Website-Erstellung",
  "sp_basic_web_desc": "Professionelle Website für Ihr Unternehmen mit modernem Design und voller mobiler Kompatibilität.",
  "sp_basic_web_feat": "Modernes responsives Design|Bis zu 5 Seiten|Kontaktformular-Integration|Mobiloptimiert|Grundlegendes SEO-Setup|Unterstützung bei der Inhaltseingabe",
  "sp_web_store_name": "Webshop / E-Commerce",
  "sp_web_store_desc": "Voll ausgestattete E-Commerce-Plattform mit integrierten Zahlungen und Marketing-Tools.",
  "sp_web_store_feat": "Kompletter Online-Shop|Zahlungsabwicklung|Produktverwaltung|Bestellverfolgung|SEO-Optimierung|Marketingstrategie inklusive",
  "sp_custom_web_name": "Individuelle Webanwendung",
  "sp_custom_web_desc": "Maßgeschneiderte Webanwendungen nach Ihren genauen Geschäftsanforderungen.",
  "sp_custom_web_feat": "Individuelles Software-Design|API-Integrationen|Datenbankarchitektur|Skalierbare Infrastruktur|Admin-Dashboards|Laufender Support",
  "sp_mobile_app_name": "Mobile Anwendung",
  "sp_mobile_app_desc": "Native und Cross-Platform mobile Anwendungen für iOS und Android.",
  "sp_mobile_app_feat": "iOS & Android|Cross-Platform-Entwicklung|Push-Benachrichtigungen|App-Store-Einreichung|UI/UX-Design|Backend-Integration",
  "sp_seo_name": "SEO & Digitales Marketing",
  "sp_seo_desc": "Steigern Sie Ihre Online-Sichtbarkeit mit umfassenden SEO- und digitalen Marketingstrategien.",
  "sp_seo_feat": "Vollständiges SEO-Audit|Keyword-Optimierung|Content-Strategie|Google Ads-Verwaltung|Social-Media-Marketing|Monatliche Berichte",
  "sp_graphic_name": "Grafikdesign & Branding",
  "sp_graphic_desc": "Komplette Branding- und Grafikdesign-Lösungen für Ihre Geschäftsidentität.",
  "sp_graphic_feat": "Logo-Design|Markenidentität|Marketingmaterialien|Social-Media-Grafiken|Druckdesign|Stilrichtlinien",
  "sp_crypto_edu_name": "Krypto-Bildungsprogramm",
  "sp_crypto_edu_desc": "Lernen Sie Kryptowährungshandel und Blockchain-Technologie von Branchenexperten.",
  "sp_crypto_edu_feat": "Blockchain-Grundlagen|Handelsstrategien|Wallet-Sicherheit|DeFi-Einführung|Marktanalyse|Persönliches Mentoring",
  "sp_invest_name": "Smarte Investment-Tools",
  "sp_invest_desc": "Professionelle Investment-Tracking- und Analyse-Tools mit KI-Unterstützung.",
  "sp_invest_feat": "Portfolio-Tracker|Markt-Dashboard|KI-gestützte Analysen|Risikobewertung|Echtzeit-Alarme|Multi-Börsen-Support",
  "sp_ad_name": "Werbedienstleistungen",
  "sp_ad_desc": "Erreichen Sie Millionen über unser umfangreiches Portal-Netzwerk in mehreren Regionen.",
  "sp_ad_feat": "20+ Portal-Netzwerk|10M+ Reichweite|Gezielte Kampagnen|Performance-Tracking|Multi-Plattform-Anzeigen|ROI-Optimierung",
  "contact_heading": "Kontaktieren Sie uns",
  "contact_subtitle_text": "Sie haben eine Frage oder möchten ein Projekt besprechen? Wir freuen uns auf Ihre Nachricht.",
  "contact_name_label": "Name",
  "contact_email_label": "E-Mail",
  "contact_subject_label": "Betreff",
  "contact_message_label": "Nachricht",
  "contact_name_ph": "Ihr Name",
  "contact_email_ph": "sie@beispiel.com",
  "contact_subject_ph": "Worum geht es?",
  "contact_message_ph": "Beschreiben Sie Ihr Projekt oder Ihre Frage...",
  "contact_send_btn": "Nachricht senden",
  "contact_sending": "Wird gesendet...",
  "contact_sent_title": "Nachricht gesendet!",
  "contact_sent_msg": "Vielen Dank für Ihre Nachricht. Wir melden uns innerhalb von 24 Stunden.",
  "contact_send_another": "Weitere Nachricht senden",
  "contact_info_email": "E-Mail",
  "contact_info_location": "Standort",
  "contact_info_eu": "Europäische Union",
  "contact_info_response": "Antwortzeit",
  "contact_info_response_time": "Innerhalb von 24 Stunden",
  "contact_info_hours": "Mo - Fr, 9:00 - 18:00 MEZ",
  "tf_seo_name": "Kostenloses SEO-Audit",
  "tf_seo_desc": "Erhalten Sie eine umfassende SEO-Analyse jeder Website - keine Registrierung erforderlich.",
  "tf_color_name": "Farbpaletten-Generator",
  "tf_color_desc": "Erstellen Sie schöne, harmonische Farbpaletten für Ihre Marke.",
  "tf_headline_name": "Überschriften-Analyzer",
  "tf_headline_desc": "Bewerten Sie Ihre Überschriften für Klickpotenzial und emotionale Wirkung.",
  "tf_chat_name": "Mit RisTA chatten",
  "tf_chat_desc": "Erhalten Sie sofortige Projektschätzungen, erkunden Sie Dienste und stellen Sie Fragen in 11 Sprachen.",
  "tf_free_label": "Kostenlos",
  "tools_seo_title": "Schneller SEO-Check",
  "tools_seo_desc": "Sofortige SEO-Bewertung für jede Website",
  "tools_seo_ph": "Website-URL eingeben (z.B. beispiel.com)",
  "tools_analyze": "Analysieren",
  "tools_color_title": "Farbpaletten-Generator",
  "tools_color_desc": "Komplementäre Farbpaletten erstellen",
  "tools_headline_title": "Überschriften-Analyzer",
  "tools_headline_desc": "Überschriften-Effektivität analysieren",
  "tools_headline_ph": "Geben Sie Ihre Überschrift ein...",
  "tools_headline_btn": "Überschrift analysieren",
  "tools_issues": "Gefundene Probleme",
  "tools_suggestions": "Vorschläge",
  "tools_score": "Punktzahl",
  "docs_heading": "Plattform-Funktionen",
  "docs_subtitle": "Alles, was Infinity Business für Ihren digitalen Erfolg bereithält.",
  "docs_no_data": "Keine Dokumentation verfügbar.",
  "tester_heading": "Tester werden",
  "tester_subtitle": "Helfen Sie uns, die Plattform zu verbessern, und erhalten Sie kostenlosen Zugang zu unseren Diensten.",
  "tester_req_title": "Was erforderlich ist",
  "tester_req_1": "Mindestens 5 Mal pro Woche anmelden",
  "tester_req_2": "Mindestens 10 Fehler-/Feedback-Berichte pro Woche einreichen",
  "tester_req_3": "Verschiedene Funktionen, Seiten und Benutzerflüsse testen",
  "tester_benefit_title": "Was Sie bekommen",
  "tester_benefit_1": "Kostenloser Zugang zu KI-Diensten (auf Anfrage)",
  "tester_benefit_2": "Tester-Dashboard mit Fortschrittsverfolgung",
  "tester_benefit_3": "Prioritäts-Support vom Team",
  "tester_apply_title": "Bewerben",
  "tester_motivation": "Warum möchten Sie Tester werden?",
  "tester_motivation_ph": "Erzählen Sie uns, warum Sie beim Testen helfen möchten...",
  "tester_experience": "Testerfahrung (optional)",
  "tester_experience_ph": "Relevante Erfahrung...",
  "tester_submit_app": "Bewerbung einreichen",
  "tester_applied_title": "Bewerbung eingereicht",
  "tester_applied_msg": "Unser Team wird Ihre Bewerbung prüfen – Sie werden benachrichtigt.",
  "tester_need_account": "Sie benötigen ein Konto zur Bewerbung.",
  "tester_dash_title": "Tester-Dashboard",
  "tester_dash_desc": "Halten Sie Ihren Tester-Status aktiv, indem Sie wöchentliche Ziele erfüllen.",
  "tester_weekly_logins": "Wöchentliche Anmeldungen",
  "tester_weekly_reports": "Wöchentliche Berichte",
  "tester_target_met": "Ziel erreicht!",
  "tester_logins_needed": "weitere Anmeldungen diese Woche nötig",
  "tester_reports_needed": "weitere Berichte diese Woche nötig",
  "tester_total_reports": "Eingereichte Berichte insgesamt",
  "tester_on_track": "Auf Kurs",
  "tester_at_risk": "Gefährdet",
  "tester_report_heading": "Fehler- / Feedback-Bericht einreichen",
  "tester_report_title_ph": "Titel (z.B. 'Button auf Mobilgerät nicht klickbar')",
  "tester_report_desc_ph": "Beschreiben Sie das Problem oder den Vorschlag im Detail...",
  "tester_report_page_ph": "Seiten-URL (optional)",
  "tester_submit_report": "Bericht einreichen",
  "seo_page_title": "Kostenloses SEO-Audit",
  "seo_page_desc": "Geben Sie eine Website-URL ein für eine umfassende SEO-Analyse mit Handlungsempfehlungen.",
  "seo_page_ph": "Website-URL eingeben (z.B. beispiel.com)",
  "seo_page_btn": "Audit starten",
  "seo_page_running": "Wird analysiert...",
  "seo_page_error": "Diese Website konnte nicht analysiert werden. Überprüfen Sie die URL und versuchen Sie es erneut.",
  "referral_reward_title": "So funktionieren Belohnungen",
  "referral_reward_desc": "Verdienen Sie 10 % bei jedem Kauf Ihrer geworbenen Nutzer – automatisch als Gratis-Guthaben gutgeschrieben.",
  "referral_reward_1": "Teilen Sie Ihren einzigartigen Empfehlungslink mit Freunden",
  "referral_reward_2": "Wenn sie einen Kauf tätigen, erhalten Sie 10% als Gratis-Credits",
  "referral_reward_3": "Credits werden automatisch Ihrem Guthaben hinzugefügt",
  "referral_earned_label": "Verdiente Credits",
  "profile_picture": "Profilbild",
  "profile_bio": "Biografie",
  "profile_website": "Website",
  "profile_interests": "Interessen",
  "profile_upload_photo": "Foto hochladen",
  "profile_bio_ph": "Erzählen Sie etwas über sich...",
  "profile_website_ph": "https://ihrewebsite.com",
  "profile_interests_ph": "z.B. Webentwicklung, Krypto, KI",
  "profile_save": "Profil speichern",
  "admin_notes": "Admin-Notizen",
  "admin_notes_ph": "Notiz zu diesem Benutzer hinzufügen...",
  "admin_notes_add": "Notiz hinzufügen",
  "sub_most_popular": "Beliebteste",
  "sub_free": "Kostenlos",
  "sub_one_time": "einmalig",
  "sub_team_members": "Teammitglieder",
  "sub_members_info": "Laden Sie Teammitglieder ein, Ihren Plan mitzunutzen. Jedes Mitglied erhält eigene Zugangsdaten und Zugriff auf die Dienste Ihres Abonnements.",
  "sub_show_less": "Weniger anzeigen",
  "sub_more_features": "weitere Funktionen",
  "sub_pay_with": "Bezahlen mit",
  "sub_preferred": "bevorzugt",
  "sub_live_crypto": "Live-Kryptopreise (EUR & USD)",
  "sp_logo_name": "Logo-Design",
  "sp_logo_desc": "Professionelles individuelles Logo-Design, das die Essenz Ihrer Marke einfängt.",
  "sp_logo_feat": "3 einzigartige Konzepte|Unbegrenzte Revisionen|Vektordateien (AI, SVG, PDF)|Vollfarbe + S/W-Versionen|Markenrichtlinien|Social-Media-Kit",
  "sp_brand_name": "Komplette Markenidentität",
  "sp_brand_desc": "Komplettes Markenidentitätspaket mit Logo, Farbpalette, Typografie und Markenrichtlinien.",
  "sp_brand_feat": "Logo-Design|Farbpalette|Typografie|Visitenkarte|Briefkopf & Umschlag|Markenrichtlinien PDF|Social-Media-Vorlagen",
  "sp_poster_name": "Poster-Design",
  "sp_poster_desc": "Auffällige Poster-Designs für Veranstaltungen und Werbekampagnen.",
  "sp_poster_feat": "Individuelle Illustration|Druckfertige Dateien|Mehrere Größen|2 Revisionsrunden|Hochauflösend|Digital + Druck",
  "sp_flyer_name": "Flyer-Design",
  "sp_flyer_desc": "Professionelle Flyer-Designs für Marketing und Veranstaltungen.",
  "sp_flyer_feat": "Vorder- & Rückseite|Druckfertige PDF|Digitale Version|QR-Code|2 Revisionsrunden|Mehrere Formate",
  "sp_menu_name": "Menü-Design",
  "sp_menu_desc": "Schöne Restaurant- und Café-Menüdesigns, die Ihr Angebot präsentieren.",
  "sp_menu_feat": "Individuelles Layout|Foto-Integration|QR-Code-Version|Druckfertige Dateien|Saisonale Updates|Mehrere Seiten",
  "currency_label": "Währung",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Wir sind ein Technologieunternehmen, das smarte digitale Lösungen entwickelt. Gegründet 2026, verbindet Infinity Business KI-Innovation mit bewährter Expertise, um Unternehmen und Einzelpersonen in der digitalen Wirtschaft voranzubringen.",
  "about_values": "Unsere Werte",
  "about_what_we_do": "Was Wir Tun",
  "about_meet_rista": "Lernen Sie RisTA kennen",
  "about_rista_desc": "RisTA ist unser KI-gestützter digitaler Assistent, der auf den neuesten KI-Modellen basiert. RisTA hilft bei der Erfassung Ihrer Projektanforderungen, bietet sofortige Beratung und verbindet Sie mit unserem Expertenteam – rund um die Uhr, in mehreren Sprachen.",
  "about_talk_rista": "Mit RisTA sprechen",
  "about_val_trust": "Vertrauen & Sicherheit",
  "about_val_trust_desc": "Wir setzen höchste Standards beim Schutz Ihrer Daten.",
  "about_val_innovation": "Innovation",
  "about_val_innovation_desc": "Modernste KI-Technologie treibt unsere Lösungen an.",
  "about_val_partnership": "Partnerschaft",
  "about_val_partnership_desc": "Wir arbeiten als echter Partner an Ihrer Seite – nicht nur als Dienstleister.",
  "about_val_global": "Globale Reichweite",
  "about_val_global_desc": "Unsere Lösungen sind auf internationale Märkte ausgelegt.",
  "about_svc_web": "Webentwicklung",
  "about_svc_web_desc": "Full-Stack-Webanwendungen, E-Commerce-Plattformen und CMS-Lösungen.",
  "about_svc_mobile": "Mobile Anwendungen",
  "about_svc_mobile_desc": "Native und plattformübergreifende Apps für iOS und Android.",
  "about_svc_software": "Individuelle Software",
  "about_svc_software_desc": "Maßgeschneiderte Softwarelösungen zur Automatisierung Ihrer Geschäftsprozesse.",
  "about_svc_invest": "Smarte Investments",
  "about_svc_invest_desc": "KI-gestützte Krypto- und DeFi-Tools mit professionellem Handelsservice.",
  "micro_tools_title": "KI-Mikro-Tools",
  "micro_tools_subtitle": "Sofortige KI-gestützte Einblicke für Leadgenerierung, Marktforschung, E-Mail-Outreach und strategische Planung.",
  "micro_tools_all": "Alle",
  "micro_tools_try": "Ausprobieren",
  "micro_tools_generate_free": "Generieren (Gratis)",
  "micro_tools_generate_paid": "Generieren",
  "micro_tools_close": "Schließen",
  "micro_tools_interested": "Interessiert?",
  "tools_view_service": "Service ansehen",
  "tools_talk_rista": "Mit RisTA sprechen",
  "competitor_title": "KI-gestützte Konkurrenzanalyse",
  "competitor_desc": "URL eingeben für eine KI-gestützte Analyse mit SEO-Vergleich und Design-Bewertung.",
  "competitor_url_ph": "Konkurrenz-URL eingeben",
  "competitor_analyze": "Konkurrenz analysieren",
  "competitor_score": "Gesamtbewertung",
  "competitor_seo": "SEO-Analyse",
  "competitor_design": "Design-Analyse",
  "competitor_content": "Inhaltsanalyse",
  "competitor_strengths": "Stärken",
  "competitor_weaknesses": "Schwächen",
  "competitor_opportunities": "Chancen",
  "competitor_recommendations": "Empfehlungen",
  "accessibility_title": "Barrierefreiheits-Check",
  "accessibility_desc": "Barrierefreiheitsstandards prüfen",
  "cat_lead_gen": "Lead-Gen & Traffic",
  "cat_discovery": "Report Discovery",
  "cat_email": "E-Mail & Workflow",
  "cat_planning": "Planung & Strategie",
  "cat_content": "Inhalt & Positionierung",
  "sp_tools_title": "Smarte Mikro-Dienste",
  "sp_tools_desc": "Sofortige KI-Dienste für Inhalte, Branding, Analyse und professionelle Dokumente.",
  "sp_free_title": "Kostenlose Tools",
  "sp_free_desc": "Testen Sie unsere Plattform mit diesen kostenlosen Tools. Kein Konto erforderlich.",
  "sp_health_score_name": "Website Health Score",
  "sp_hosting_name": "Managed Web Hosting",
  "sp_biz_plan_name": "Smarter Businessplan",
  "sp_seo_report_name": "Website-Audit-Bericht",
  "sp_email_campaign_name": "E-Mail-Marketing-Setup",
  "sp_competitor_name": "Konkurrenzanalyse",
  "sp_legal_docs_name": "Rechtsdokument-Generator",
  "sp_resume_name": "Smarter Lebenslauf",
  "sp_brand_kit_name": "Smartes Branding-Kit",
  "sp_social_cal_name": "Social-Media-Kalender",
  "sp_translation_name": "Smarte Übersetzung",
  "sp_video_script_name": "Smarter Videoskript-Autor",
  "sp_free_seo_name": "Kostenloses SEO-Audit",
  "sp_free_tools_name": "Kostenlose digitale Tools",
  "a11y_checker": "Barrierefreiheitsprüfung",
  "a11y_compliant": "Konform",
  "a11y_disclaimer": "Automatische Prüfungen decken ~30% der Barrierefreiheitsprobleme ab. Manuelle Tests mit Screenreadern werden empfohlen.",
  "a11y_error": "Prüfung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "a11y_incomplete": "Überprüfung erforderlich",
  "a11y_issues_found": "Probleme gefunden",
  "a11y_no_issues": "Keine Barrierefreiheitsprobleme gefunden!",
  "a11y_passed": "bestanden",
  "a11y_rescan": "Erneut scannen",
  "a11y_scanning": "WCAG-Prüfung wird durchgeführt...",
  "a11y_violations": "Verstöße",
  "admin_ab_testing": "A/B-Tests",
  "admin_account_mgmt": "Kontoverwaltung",
  "admin_actions": "Aktionen",
  "admin_active": "Aktiv",
  "admin_ad_gen": "Anzeigengenerator",
  "admin_add_milestone": "Meilenstein hinzufügen",
  "admin_adv_reports": "Erweiterte Berichte",
  "admin_ai_config": "Modellkonfiguration",
  "admin_ai_prompts": "KI-Prompts",
  "admin_analytics": "Analytik",
  "admin_audit": "Plattformprüfung",
  "admin_audit_trail": "Prüfprotokoll",
  "admin_auto_posting": "KI-Auto-Posting",
  "admin_avatar_builder": "Avatar-Builder",
  "admin_avatar_selector": "Avatar-Auswahl",
  "admin_avg_exp": "Durchschn. Erfahrung",
  "admin_avg_rating": "Durchschn. Bewertung",
  "admin_backup": "Sicherung & Wiederherstellung",
  "admin_billing": "Wiederkehrende Abrechnung",
  "admin_blog": "Blog-Manager",
  "admin_bug_reports": "Fehlermeldungen",
  "admin_cancel": "Abbrechen",
  "admin_cdn": "CDN-Manager",
  "admin_chat_analytics": "Chat-Analytik",
  "admin_chat_sessions": "Chat-Sitzungen",
  "admin_client_portal": "Kundenportal",
  "admin_abandoned_carts": "Verlassene Warenkörbe",
  "rista_login_required": "Anmeldung erforderlich",
  "rista_login_desc": "Melden Sie sich an oder erstellen Sie ein Konto, um mit RisTA zu chatten und personalisierte Geschäftsempfehlungen zu erhalten.",
  "rista_login_btn": "Anmelden",
  "rista_signup_btn": "Registrieren",
  "admin_created": "Erstellt",
  "admin_credits": "Kredit-Konfiguration",
  "admin_crypto_payments": "Krypto-Zahlungen",
  "admin_crypto_trading": "Krypto-Handel",
  "admin_currency": "Mehrere Währungen",
  "admin_defi": "DeFi-Elemente",
  "admin_delete": "Löschen",
  "admin_demo": "Demo-Zugang",
  "admin_demo_banner": "NUR-LESEN-MODUS - Demo-Betrachter-Konto (Alle Benutzerdaten sind maskiert)",
  "admin_docs": "Dokumentation",
  "admin_domain": "Domain-Manager",
  "admin_edit": "Bearbeiten",
  "admin_email_builder": "E-Mail-Builder",
  "admin_email_templates": "E-Mail-Vorlagen",
  "admin_email_templates_desc": "Passen Sie E-Mail-Vorlagen mit dem visuellen Block-Editor an.",
  "admin_escalations": "Chat-Eskalationen",
  "admin_fb": "FB-Analytik",
  "admin_followups": "Nachfass-E-Mails",
  "admin_health": "Gesundheitsmonitor",
  "admin_health_monitor": "Gesundheitsüberwachung",
  "admin_health_score": "Gesundheitsbewertung",
  "admin_high_leads": "Prioritäts-Leads",
  "admin_high_value": "Hochwertige Leads",
  "admin_image_gen": "Bildgenerierung",
  "admin_integrations": "Integrationen",
  "admin_invoices": "Rechnungsstellung",
  "admin_kb": "Wissensdatenbank",
  "admin_language_requests": "Sprachanfragen",
  "admin_lead_tracking": "Lead-Tracking",
  "admin_live_analytics": "Live-Analytik",
  "admin_loading": "Laden...",
  "admin_logo": "Logo & Favicon",
  "admin_milestone_desc": "Beschreibung (optional)",
  "admin_milestone_title": "Meilensteintitel",
  "admin_my_account": "Mein Konto",
  "admin_new": "neu",
  "admin_no_data": "Keine Daten verfügbar",
  "admin_no_matching": "Keine passenden Tabs",
  "admin_no_milestones": "Noch keine Meilensteine. Fügen Sie den ersten hinzu!",
  "admin_notifications": "Benachrichtigungen",
  "admin_out_of": "Von",
  "admin_overview": "Übersicht",
  "admin_panel": "Admin-Panel",
  "admin_payment_opts": "Zahlungsoptionen",
  "admin_pending": "Ausstehend",
  "admin_portfolio": "Portfolio-Manager",
  "admin_preloader": "Preloader-Konfiguration",
  "admin_pricing": "Dynamische Preisgestaltung",
  "admin_promo": "Promo-Codes",
  "admin_rate_limiting": "Ratenbegrenzung",
  "admin_rbac": "Zugriffskontrolle",
  "admin_referral_board": "Empfehlungs-Rangliste",
  "admin_referrals": "Empfehlungsprogramm",
  "admin_reports": "Admin-Berichte",
  "admin_requests": "Serviceanfragen",
  "admin_reviews": "Bewertungen",
  "admin_rista": "RisTA-Dienste",
  "admin_save": "Speichern",
  "admin_score": "Ergebnis",
  "admin_search_tabs": "Tabs durchsuchen...",
  "admin_sendgrid": "E-Mail (SendGrid)",
  "admin_service_mgr": "Service-Manager",
  "admin_sign_out": "Abmelden",
  "admin_social": "Soziale Medien",
  "admin_social_auto": "Social-Media-Automatisierung",
  "admin_social_icons": "Social-Media-Symbole",
  "admin_status": "Status",
  "admin_surveys": "Zufriedenheitsumfragen",
  "admin_system_admin": "SYSTEMADMINISTRATOR",
  "admin_system_config": "Systemkonfiguration",
  "admin_tester": "Testerprogramm",
  "admin_timeline": "Projekt-Zeitachse",
  "admin_total": "Gesamt",
  "admin_ui_toggles": "UI-Schalter",
  "admin_unread": "Ungelesen",
  "admin_updated": "Aktualisiert",
  "admin_users": "Benutzerverwaltung",
  "admin_view_all": "Alle anzeigen",
  "billing_manage_desc": "Verwalten Sie Zahlungsmethoden, sehen Sie Rechnungen ein oder aktualisieren Sie Ihre Abrechnungsdaten über das Stripe-Portal.",
  "change_password_social": "Passwortänderung ist für Social-Login-Konten nicht verfügbar.",
  "health_a11y": "Barrierefreiheit",
  "health_desc": "SEO, Performance, Sicherheit und Barrierefreiheit Ihrer Website auf einen Blick.",
  "health_history": "Scan-Verlauf",
  "health_login_desc": "Erstellen Sie ein kostenloses Konto, um Ihre Website zu scannen und Fortschritte zu verfolgen.",
  "health_login_required": "Anmelden zur Nutzung der Gesundheitsbewertung",
  "health_overall": "Gesamt-Gesundheitsbewertung",
  "health_perf": "Leistung",
  "health_premium_badge": "Premium-Funktion",
  "health_response": "Antwort",
  "health_scan_btn": "Scannen",
  "health_scan_error": "Website-Scan fehlgeschlagen. Bitte überprüfen Sie die URL.",
  "health_scanning": "Scannen...",
  "health_security": "Sicherheit",
  "health_seo": "SEO",
  "health_size": "Größe",
  "health_title": "Website-Gesundheitsbewertung",
  "health_upgrade_btn": "Auf Premium upgraden",
  "health_upsell_desc": "Mit Premium erhalten Sie automatische wöchentliche Scans, E-Mail-Benachrichtigungen und Trendanalysen.",
  "health_upsell_title": "Wiederkehrende Überwachung gewünscht?",
  "health_url_ph": "Website-URL eingeben (z.B. example.com)",
  "nav_currency": "Währung",
  "nav_health_score": "Gesundheitsbewertung",
  "nav_orders": "Meine Bestellungen",
  "priority_critical": "Kritisch",
  "priority_high": "Hoch",
  "priority_low": "Niedrig",
  "priority_medium": "Mittel",
  "profile_about": "Über Sie",
  "profile_change_avatar": "Avatar ändern",
  "profile_country": "Land",
  "profile_country_ph": "z.B. Deutschland, Österreich, Schweiz",
  "profile_interests_hint": "Interessen mit Kommas trennen",
  "seo_cta_desc": "Unsere KI-gestützte SEO-Prüfung deckt über 100 Prüfpunkte ab. Holen Sie sich professionelle Unterstützung bei der Optimierung.",
  "seo_cta_title": "Brauchen Sie Hilfe bei diesen Problemen?",
  "sp_biz_plan_desc": "Erstellen Sie einen umfassenden Businessplan mit Finanzen, Marktanalyse und Wachstumsstrategie.",
  "sp_biz_plan_feat": "Zusammenfassung|Marktanalyse|Finanzprognosen|Wettbewerbsüberblick|Wachstumsstrategie|Investorengerechtes Format",
  "sp_brand_kit_desc": "Komplettes Markenidentitätspaket mit Logo-Konzepten, Farbpalette und Social-Media-Assets.",
  "sp_brand_kit_feat": "Logo-Konzepte|Farbpalette|Typografie|Social-Media-Assets|Markenrichtlinien|Icon-Set",
  "sp_competitor_desc": "Tiefe Wettbewerbsanalyse mit SEO-Vergleich, Designbewertung und Inhaltslückenanalyse.",
  "sp_competitor_feat": "SEO-Vergleich|Design-Review|Inhaltslücken|Marktpositionierung|SWOT-Analyse|Strategieempfehlungen",
  "sp_email_campaign_desc": "Professionelles E-Mail-Kampagnen-Setup mit Text, Sequenzen und Zielgruppenausrichtung.",
  "sp_email_campaign_feat": "E-Mail-Texterstellung|Sequenz-Setup|Zielgruppenausrichtung|A/B-Tests|Analytics-Setup|Vorlagen-Design",
  "sp_free_seo_desc": "Führen Sie eine kostenlose SEO-Prüfung jeder Website durch, um Optimierungsmöglichkeiten zu entdecken.",
  "sp_free_seo_feat": "Sofortige Ergebnisse|100+ Prüfungen|Leistungsbewertung|Mobilprüfung|Sicherheitsscan|Kostenloser Bericht",
  "sp_free_tools_desc": "Zugriff auf unsere Sammlung kostenloser Tools inkl. Farbpaletten, Schlagzeilen-Analysatoren und mehr.",
  "sp_free_tools_feat": "Farbpaletten-Generator|Schlagzeilen-Analysator|Passwort-Generator|QR-Code-Ersteller|Einheitenumrechner|Keine Registrierung nötig",
  "sp_health_score": "Website-Gesundheitsbewertung",
  "sp_health_score_desc": "Umfassende Website-Analyse für SEO, Leistung, Sicherheit und Barrierefreiheit.",
  "sp_health_score_feat": "SEO-Analyse|Leistungsprüfung|Sicherheitsscan|Barrierefreiheitsprüfung|Detaillierter Bericht|Verbesserungstipps",
  "sp_hosting_desc": "Sichere, schnelle und zuverlässige Hosting-Infrastruktur für Ihre Websites und Anwendungen.",
  "sp_hosting_feat": "99,9% Verfügbarkeit|SSL-Zertifikate|Tägliche Backups|CDN-Integration|24/7-Überwachung|Auto-Skalierung",
  "sp_legal_docs_desc": "Professionelle Rechtsvorlagen inkl. NDA, Verträge und AGB.",
  "sp_legal_docs_feat": "NDA-Vorlagen|Dienstleistungsverträge|AGB|Datenschutzrichtlinien|DSGVO-Konformität|Individuelle Klauseln",
  "sp_resume_desc": "Erstellen Sie ATS-optimierte Lebensläufe, zugeschnitten auf Ihre Zielrolle.",
  "sp_resume_feat": "ATS-Optimierung|Branchenvorlagen|Keyword-Matching|Anschreiben|LinkedIn-Optimierung|PDF-Export",
  "sp_seo_report_desc": "Automatisierte Seitenanalyse mit umsetzbaren SEO-Empfehlungen und Leistungseinblicken.",
  "sp_seo_report_feat": "100+ Prüfpunkte|Leistungskennzahlen|SEO-Empfehlungen|Mobile Analyse|Sicherheitsüberprüfung|Aktionsplan",
  "sp_social_cal_desc": "30 Tage intelligent generierter Social-Media-Inhalte mit Engagement-Strategie.",
  "sp_social_cal_feat": "30-Tage-Kalender|Post-Texte|Hashtag-Strategie|Engagement-Tipps|Beste Posting-Zeiten|Plattform-Optimierung",
  "sp_translation_desc": "Professionelle Dokumentenübersetzung in 50+ Sprachen mit kultureller Anpassung.",
  "sp_translation_feat": "50+ Sprachen|Kulturelle Anpassung|Fachbegriffe|Schnelle Lieferung|Korrekturlesen|Formatbeibehaltung",
  "sp_video_script_desc": "Ansprechende Videoskripte für YouTube, TikTok und Anzeigen, optimiert für maximales Engagement.",
  "sp_video_script_feat": "YouTube-Skripte|TikTok-Inhalte|Anzeigentexte|Hook-Optimierung|CTA-Platzierung|Engagement-Tipps",
  "status_blocked": "Blockiert",
  "status_completed": "Abgeschlossen",
  "status_in_progress": "In Bearbeitung",
  "status_planned": "Geplant",
  "admin_ratings": "Bewertungen & Feedback",
  "analytics_subscription": "Abonnement",
  "developer_title": "Entwickler-API",
  "developer_subtitle": "Integrieren Sie unsere KI-Dienste in Ihre Anwendungen",
  "estimate_accept": "Akzeptieren & Absenden",
  "estimate_revise": "Überarbeiten",
  "estimate_title": "Projektkostenschätzung",
  "estimate_service": "Dienst",
  "estimate_complexity": "Komplexität",
  "estimate_base_price": "Grundpreis",
  "estimate_cost": "Geschätzte Kosten",
  "estimate_features": "Hauptmerkmale",
  "hosting_title": "Hosting-Pakete",
  "hosting_subtitle": "Zuverlässiges, schnelles Hosting für Ihr Unternehmen",
  "privacy_s1_title": "1. Informationen, die wir erfassen",
  "privacy_s2_title": "2. Wie wir Ihre Informationen verwenden",
  "privacy_s3_title": "3. Datenweitergabe",
  "privacy_s4_title": "4. Datensicherheit",
  "privacy_s5_title": "5. Ihre Rechte",
  "privacy_s6_title": "6. Cookies & Tracking",
  "privacy_s7_title": "7. Datenspeicherung",
  "privacy_s8_title": "8. Internationale Übermittlungen",
  "privacy_s9_title": "9. Änderungen dieser Richtlinie",
  "privacy_s10_title": "10. Kontaktieren Sie uns",
  "privacy_intro": "Infinity Business (\"wir\", \"uns\", \"unser\"), betrieben von Liber Nostra d.o.o., ist dem Schutz Ihrer Privatsphäre verpflichtet.",
  "privacy_last_updated": "Zuletzt aktualisiert: 7. März 2026",
  "terms_s1_title": "1. Einleitung",
  "terms_s2_title": "2. Dienstleistungen",
  "terms_s3_title": "3. Benutzerkonten",
  "terms_s4_title": "4. Zahlungen und Abrechnung",
  "terms_s5_title": "5. Haftungsausschluss für KI-Dienste",
  "terms_s6_title": "6. Geistiges Eigentum",
  "terms_s7_title": "7. Datenschutz und Daten",
  "terms_s8_title": "8. Kryptowährungs-Haftungsausschluss",
  "terms_s9_title": "9. Haftungsbeschränkung",
  "terms_s10_title": "10. Änderungen",
  "terms_s11_title": "11. Anwendbares Recht",
  "terms_s12_title": "12. Kontakt",
  "terms_last_updated": "Zuletzt aktualisiert: Februar 2026",
  "profile_admin_dashboard": "Admin-Dashboard öffnen",
  "review_title": "Was unsere Kunden sagen",
  "review_subtitle": "Echtes Feedback von Unternehmen, die wir begleitet haben",
  "submit_service_request": "Serviceanfrage einreichen",
  "walkthrough_gmail": "Smarter Gmail-Assistent",
  "walkthrough_gmail_desc": "Sehen Sie, wie RisTA Ihren Posteingang organisiert",
  "walkthrough_calendar": "Persönlicher Berater",
  "walkthrough_calendar_desc": "Kalender, Aufgaben und E-Mail per Chat",
  "walkthrough_ai": "KI-Dienste",
  "walkthrough_ai_desc": "Lebenslauf, Geschäftspläne, Markenpakete & mehr",
  "try_free_title": "Kostenlose Tools und Probeservices",
  "try_free_subtitle": "Keine Kreditkarte nötig. Legen Sie direkt los.",
  "try_free_section": "Komplett kostenlos — kein Konto nötig",
  "try_free_trial_section": "KI-Dienste – mit Guthaben testen",
  "try_free_trial_desc": "Melden Sie sich für einen Plan an, um Guthaben und Zugang zu KI-Diensten zu erhalten.",
  "try_free_cta": "Bereit loszulegen?",
  "try_free_cta_desc": "Erstellen Sie ein kostenloses Konto, sichern Sie sich Ihre ersten Credits und nutzen Sie alle KI-Dienste.",
  "try_free_cta_btn": "Kostenlos registrieren",
  "referral_subtitle": "Freunde einladen und Belohnungen verdienen",
  "support_tickets": "Support-Tickets",
  "admin_support_tickets": "Support-Tickets",
  "admin_auto_translate": "Auto-Übersetzung",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "KI-Akquise",
  "admin_project_mgmt": "Projektmanagement",
  "admin_analytics_widget": "Analyse-Widget",
  "admin_doc_mgmt": "Dokumentenverwaltung",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "White-Label",
  "admin_multi_tenant": "Mandantenfähig",
  "popular_services": "Beliebte Dienste",
  "popular_services_desc": "Am häufigsten von unseren Kunden angefragt",
  "purchases": "Einkäufe",
  "admin_funnel": "Konversionstrichter",
  "admin_wl_licensing": "SaaS-Lizenzierung",
  "admin_analytics_export": "Analyse-Export",
  "service_detail_features": "Was enthalten ist",
  "service_detail_related": "Ähnliche Dienste",
  "service_detail_back": "Alle Dienste",
  "checkout_currency": "Checkout-Währung",
  "upsell_title": "Vervollständigen Sie Ihr Setup",
  "upsell_desc": "Kunden, die ähnliches gekauft haben, fügten auch hinzu:",
  "cart_checkout": "Zur Kasse",
  "cart_empty": "Ihr Warenkorb ist leer",
  "push_notifications": "Push-Benachrichtigungen",
  "push_enabled": "Benachrichtigungen aktiviert",
  "push_disabled": "Benachrichtigungen aktivieren",
  "blog_ai_generate": "KI-Generierung",
  "blog_gen_service": "Für Service generieren",
  "blog_generating": "Wird generiert...",
  "export_revenue": "Umsatzbericht",
  "export_funnel": "Konversionstrichter",
  "export_users": "Benutzerliste",
  "export_pdf": "Zusammenfassung",
  "license_generate": "Lizenz generieren",
  "license_revoke": "Widerrufen",
  "license_renew": "Verlängern",
  "license_validate": "Validieren",
  "tier_starter": "Starter",
  "tier_professional": "Professional",
  "tier_enterprise": "Enterprise",
  "blog_subtitle": "Einblicke, Updates und Leitfäden von Infinity Business.",
  "blog_search_placeholder": "Artikel suchen...",
  "blog_all": "Alle",
  "blog_no_posts": "Noch keine Beiträge vorhanden. Schauen Sie bald wieder vorbei!",
  "blog_prev": "Zurück",
  "blog_next": "Weiter",
  "blog_back": "Zurück zum Blog",
  "micro_tools": "KI-Mikro-Tools",
  "micro_tools_title": "KI-Mikro-Tools",
  "micro_tools_subtitle": "Kostenlose KI-Mikro-Tools für Ihr Unternehmen",
  "color_palette_title": "Farbpaletten-Generator",
  "color_palette_desc": "Erstellen Sie schöne Farbpaletten für Ihre Marke",
  "color_palette_generate": "Palette generieren",
  "color_palette_copy": "Kopieren",
  "color_palette_copied": "Kopiert!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Komplementär",
  "color_palette_analogous": "Analog",
  "color_palette_triadic": "Triadisch",
  "color_palette_monochromatic": "Monochromatisch",
  "admin_menu_overview": "Übersicht",
  "admin_menu_users": "Benutzer",
  "admin_menu_blog": "Blog-Manager",
  "admin_menu_analytics": "Analytik",
  "admin_menu_settings": "Einstellungen",
  "admin_menu_services": "Dienste",
  "admin_menu_chat": "Chat-Sitzungen",
  "admin_menu_notifications": "Benachrichtigungen",
  "admin_menu_support": "Support",
  "admin_menu_security": "Sicherheit",
  "admin_menu_backup": "Sicherung",
  "admin_menu_revenue": "Umsatz",
  "admin_menu_funnel": "Trichter",
  "admin_menu_invoicing": "Rechnungsstellung",
  "admin_menu_projects": "Projekte",
  "admin_menu_email": "E-Mail-Builder",
  "admin_menu_ai_config": "KI-Konfiguration",
  "admin_menu_live_analytics": "Live-Analytik",
  "admin_menu_platform_audit": "Plattform-Audit",
  "docs_title": "Dokumentation",
  "docs_subtitle": "Erfahren Sie, wie Sie unsere Plattform nutzen",
  "try_free_title": "Kostenlos testen",
  "try_free_subtitle": "Erleben Sie unsere Dienste kostenlos",
  "subscription_title": "Abonnement-Pläne",
  "subscription_subtitle": "Wählen Sie den Plan, der zu Ihnen passt",
  "portfolio_title": "Portfolio",
  "portfolio_subtitle": "Unsere Arbeit spricht für sich",
  "svc_web-dev_label": "Webentwicklung",
  "svc_web-dev_desc": "Individuelle Websites, Landingpages und Webanwendungen",
  "svc_mobile-app_label": "Mobile App Entwicklung",
  "svc_mobile-app_desc": "iOS & Android Apps, plattformübergreifende Lösungen",
  "svc_graphic-design_label": "Grafikdesign",
  "svc_graphic-design_desc": "Logos, Branding, Marketingmaterialien",
  "svc_custom-software_label": "Individuelle Software",
  "svc_custom-software_desc": "Maßgeschneiderte Automatisierung und Unternehmenstools",
  "svc_ai-business-plan_label": "KI-Businessplan-Generator",
  "svc_ai-business-plan_desc": "Vollständiger Businessplan mit Finanzen und Marktanalyse",
  "svc_ai-seo-report_label": "Website-Audit & SEO-Bericht",
  "svc_ai-seo-report_desc": "Automatisierte Seitenanalyse mit Handlungsempfehlungen",
  "svc_ai-email-campaign_label": "E-Mail-Marketing-Setup",
  "svc_ai-email-campaign_desc": "KI erstellt Texte und richtet E-Mail-Sequenzen ein",
  "svc_ai-competitor-analysis_label": "Wettbewerbsanalyse-Bericht",
  "svc_ai-competitor-analysis_desc": "Marktintelligenz und Wettbewerbspositionierung",
  "svc_ai-legal-docs_label": "Rechtsdokument-Generator",
  "svc_ai-legal-docs_desc": "NDA, Verträge, AGB-Vorlagen",
  "svc_crypto-education_label": "Krypto-Bildung",
  "svc_crypto-education_desc": "Blockchain, DeFi und Krypto-Grundlagen lernen",
  "svc_investment-tools_label": "Investitionstools",
  "svc_investment-tools_desc": "Portfolio-Tracking und Marktanalyse-Dashboards",
  "svc_defi-solutions_label": "DeFi-Lösungen",
  "svc_defi-solutions_desc": "Smart Contracts, Yield Farming, Liquiditätspools",
  "svc_personal-advertising_label": "Persönliches Branding",
  "svc_personal-advertising_desc": "Bauen Sie Ihre Online-Präsenz und persönliche Marke auf",
  "svc_ai-resume_label": "KI-Lebenslauf-Builder",
  "svc_ai-resume_desc": "ATS-optimierte Lebensläufe",
  "svc_ai-brand-kit_label": "KI-Logo & Brand Kit",
  "svc_ai-brand-kit_desc": "Logo, Farbpalette, Typografie und Social Assets",
  "svc_ai-social-calendar_label": "Social-Media-Kalender & Analyse",
  "svc_ai-social-calendar_desc": "30 Tage KI-generierte Posts mit Engagement-Strategie",
  "svc_ai-translation_label": "KI-Übersetzungsservice",
  "svc_ai-translation_desc": "Professionelle Dokumentenübersetzung in 50+ Sprachen",
  "svc_ai-video-script_label": "KI-Video-Skript-Writer",
  "svc_ai-video-script_desc": "YouTube, TikTok und Werbeskripte",
  "admin_grp_dashboard": "Übersicht",
  "admin_grp_users": "Benutzer & Zugriff",
  "admin_grp_analytics": "Analytik & Berichte",
  "admin_grp_services": "Dienste & Preise",
  "admin_grp_crypto": "Krypto & DeFi",
  "admin_grp_leads": "Leads & CRM",
  "admin_grp_content": "Inhalte",
  "admin_grp_comm": "Kommunikation",
  "admin_grp_social": "Soziale Medien",
  "admin_grp_ai": "KI & Automatisierung",
  "admin_grp_design": "Design & Branding",
  "admin_grp_system": "System",
  "admin_grp_projects": "Projekte & QA",
  "color_palette_professional": "Professionell",
  "color_palette_playful": "Verspielt",
  "color_palette_luxury": "Luxus",
  "color_palette_nature": "Natur",
  "color_palette_tech": "Technik",
  "color_palette_warm": "Warm",
  "color_palette_cool": "Kühl",
  "blog_translating": "Artikel wird übersetzt...",
  "blog_translated_cached": "Übersetzt",
  "blog_translated_fresh": "Gerade übersetzt",
  "blog_show_original": "Original anzeigen",
  "privacy_s1_content": "Wir erheben Informationen, die Sie uns direkt mitteilen, einschließlich:\n- **Kontoinformationen**: Name, E-Mail-Adresse und Passwort bei der Kontoerstellung.\n- **Serviceanfragen**: Projektdetails, Budget, Zeitplan und Kontaktinformationen.\n- **Zahlungsdaten**: Abrechnungsdaten, die sicher über unsere Zahlungspartner (Stripe, myPOS) verarbeitet werden.\n- **Kommunikationsdaten**: Nachrichten über unseren Chat mit RisTA, Kontaktformulare und E-Mail-Korrespondenz.\n- **Nutzungsdaten**: Browsertyp, IP-Adresse, besuchte Seiten und Interaktionsmuster.",
  "privacy_s2_content": "Wir verwenden die gesammelten Informationen, um:\n- Unsere Dienste bereitzustellen, zu pflegen und zu verbessern\n- Transaktionen zu verarbeiten und zugehörige Informationen zu senden\n- Technische Hinweise, Updates und Support-Nachrichten zu senden\n- Auf Ihre Kommentare, Fragen und Kundendienstanfragen zu antworten\n- Trends, Nutzung und Aktivitäten zu überwachen und zu analysieren\n- Betrügerische Transaktionen und andere illegale Aktivitäten zu erkennen und zu verhindern\n- Ihre Erfahrung mit unserem KI-Assistenten (RisTA) zu personalisieren",
  "privacy_s3_content": "Wir verkaufen Ihre personenbezogenen Daten nicht. Wir können Informationen weitergeben an:\n- **Dienstleister**: Drittunternehmen, die Dienste in unserem Auftrag erbringen.\n- **Rechtliche Anforderungen**: Wenn gesetzlich vorgeschrieben.\n- **Geschäftsübertragungen**: Im Zusammenhang mit Fusionen oder Verkäufen.\n- **Einwilligung**: Mit Ihrer ausdrücklichen Zustimmung.",
  "privacy_s4_content": "Wir implementieren branchenübliche Sicherheitsmaßnahmen:\n- Verschlüsselung der Daten während der Übertragung (TLS/SSL) und im Ruhezustand\n- Unterstützung der Zwei-Faktor-Authentifizierung (2FA)\n- Regelmäßige Sicherheitsaudits\n- Zugangskontrollen und Authentifizierung\n- Sichere Zahlungsabwicklung über PCI-konforme Partner",
  "privacy_s5_content": "Gemäß den geltenden Datenschutzgesetzen (einschließlich DSGVO) haben Sie das Recht auf:\n- **Zugang**: Eine Kopie Ihrer personenbezogenen Daten anfordern\n- **Berichtigung**: Korrektur ungenauer Daten verlangen\n- **Löschung**: Löschung Ihrer Daten verlangen\n- **Einschränkung**: Einschränkung der Verarbeitung verlangen\n- **Datenübertragbarkeit**: Übertragung in maschinenlesbarem Format\n- **Widerspruch**: Der Verarbeitung widersprechen\n- **Widerruf der Einwilligung**: Einwilligung jederzeit widerrufen\n\nKontaktieren Sie uns unter privacy@infinitybusiness.org.",
  "privacy_s6_content": "Wir verwenden essentielle Cookies für Ihre Sitzung und Einstellungen. Sie können Cookie-Einstellungen über Ihren Browser steuern.",
  "privacy_s7_content": "Wir bewahren Ihre Daten nur so lange auf, wie es für die Zwecke erforderlich ist, für die sie erhoben wurden.",
  "privacy_s8_content": "Ihre Daten können in Länder außerhalb des EWR übertragen werden. Wir stellen geeignete Schutzmaßnahmen sicher.",
  "privacy_s9_content": "Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wesentliche Änderungen werden auf dieser Seite veröffentlicht.",
  "privacy_s10_content": "Bei Fragen kontaktieren Sie:\n\n**Liber Nostra d.o.o.**\nE-Mail: privacy@infinitybusiness.org\nWebsite: infinitybusiness.org",
  "terms_s1_content": "Willkommen bei Infinity Business (\"infinitybusiness.org\"), betrieben von **Liber Nostra d.o.o.**. Durch den Zugriff auf unsere Plattform stimmen Sie diesen Nutzungsbedingungen zu.",
  "terms_s2_content": "Infinity Business bietet KI-gestützte digitale Dienste an, darunter:\n- Webentwicklung, mobile App-Entwicklung und Grafikdesign (B2B)\n- Unternehmens- und digitale Werbedienste\n- Kryptowährungsbildung, Investitionstools und DeFi-Dashboards (P2P)\n- RisTA KI-Assistent (einmalige und Abonnement-Dienste)\n- Domain-Aftermarket und Webhosting",
  "terms_s3_content": "Für bestimmte Funktionen müssen Sie ein Konto erstellen. Sie sind für die Vertraulichkeit Ihrer Zugangsdaten verantwortlich.",
  "terms_s4_content": "Dienste können Zahlungen erfordern. Zahlungen werden über Drittanbieter verarbeitet (Stripe, PayPal, Kryptowährung). Erstattungsrichtlinien:\n- **Einmalige Dienste**: Nicht erstattungsfähig nach Lieferung.\n- **Abonnements**: Jederzeit kündbar.\n- **Individuelle Projekte**: Gemäß individueller Projektvereinbarung.",
  "terms_s5_content": "Unser KI-Assistent \"RisTA\" bietet automatisierte Beratung und Kostenschätzungen. Diese dienen ausschließlich zu Informationszwecken.",
  "terms_s6_content": "Alle Inhalte, Designs, Code und Materialien auf dieser Plattform sind Eigentum von Liber Nostra d.o.o.",
  "terms_s7_content": "Ihre Nutzung der Plattform unterliegt auch unserer Datenschutzrichtlinie.",
  "terms_s8_content": "Alle kryptowährungsbezogenen Dienste dienen nur zu Informationszwecken. Wir bieten keine Finanzberatung.",
  "terms_s9_content": "Liber Nostra d.o.o. haftet nicht für indirekte, zufällige oder Folgeschäden.",
  "terms_s10_content": "Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern.",
  "terms_s11_content": "Diese Bedingungen unterliegen den Gesetzen der Republik Slowenien.",
  "terms_s12_content": "Für Fragen kontaktieren Sie uns oder schreiben Sie an support@infinitybusiness.org.",
  "admin_ad_generator": "Anzeigengenerator",
  "admin_add": "Hinzufügen",
  "admin_add_prompt": "Prompt hinzufügen",
  "admin_admin": "Administrator",
  "admin_advanced_reporting": "Erweitertes Reporting",
  "admin_all": "Alle",
  "admin_analytics_dashboard": "Analyse-Dashboard",
  "admin_api_key": "API-Schlüssel",
  "admin_apply": "Anwenden",
  "admin_approved": "Genehmigt",
  "admin_archive": "Archivieren",
  "admin_are_you_sure": "Sind Sie sicher?",
  "admin_audit_alerts": "Audit-Warnungen",
  "admin_author": "Autor",
  "admin_avg_session": "Durchschn. Sitzungsdauer",
  "admin_back": "Zurück",
  "admin_badge": "Abzeichen",
  "admin_balance": "Guthaben",
  "admin_banned": "Gesperrt",
  "admin_blog_manager": "Blog-Verwaltung",
  "admin_body": "Inhalt",
  "admin_bounce_rate": "Absprungrate",
  "admin_browser": "Browser",
  "admin_campaign": "Kampagne",
  "admin_cannot_undo": "Diese Aktion kann nicht rückgängig gemacht werden",
  "admin_category": "Kategorie",
  "admin_click_rate": "Klickrate",
  "admin_close": "Schliessen",
  "admin_completed": "Abgeschlossen",
  "admin_configuration": "Konfiguration",
  "admin_confirm": "Bestätigen",
  "admin_contact_info": "Kontaktdaten",
  "admin_content": "Inhalt",
  "admin_conversations": "Gespräche",
  "admin_conversion_funnel": "Konversionstrichter",
  "admin_conversion_rate": "Konversionsrate",
  "admin_copied": "In Zwischenablage kopiert",
  "admin_copy": "Kopieren",
  "admin_count": "Anzahl",
  "admin_country": "Land",
  "admin_create": "Erstellen",
  "admin_create_experiment": "Experiment erstellen",
  "admin_create_new": "Neu erstellen",
  "admin_created_success": "Erfolgreich erstellt",
  "admin_credit_config": "Guthaben-Konfiguration",
  "admin_critical": "Kritisch",
  "admin_custom": "Benutzerdefiniert",
  "admin_daily": "Täglich",
  "admin_date": "Datum",
  "admin_delete_failed": "Löschen fehlgeschlagen",
  "admin_deleted_success": "Erfolgreich gelöscht",
  "admin_demo_access": "Demo-Zugang",
  "admin_description": "Beschreibung",
  "admin_deselect_all": "Alle abwählen",
  "admin_details": "Details",
  "admin_device": "Gerät",
  "admin_disable": "Deaktivieren",
  "admin_disabled": "Deaktiviert",
  "admin_doc_viewer": "Dokumentenansicht",
  "admin_documentation": "Dokumentation",
  "admin_download": "Herunterladen",
  "admin_draft": "Entwurf",
  "admin_duplicate": "Duplizieren",
  "admin_email": "E-Mail",
  "admin_enable": "Aktivieren",
  "admin_enabled": "Aktiviert",
  "admin_end_date": "Enddatum",
  "admin_endpoint": "Endpunkt",
  "admin_error": "Fehler",
  "admin_escalation_queue": "Eskalationswarteschlange",
  "admin_event": "Ereignis",
  "admin_events": "Ereignisse",
  "admin_experiment_name": "Experimentname",
  "admin_export": "Exportieren",
  "admin_facebook_analytics": "Facebook-Analyse",
  "admin_false": "Falsch",
  "admin_filter": "Filtern",
  "admin_frequency": "Häufigkeit",
  "admin_generate": "Generieren",
  "admin_headers": "Header",
  "admin_health_monitoring": "Gesundheitsüberwachung",
  "admin_high": "Hoch",
  "admin_high_value_leads": "Hochwertige Leads",
  "admin_id": "ID",
  "admin_image": "Bild",
  "admin_import": "Importieren",
  "admin_in_progress": "In Bearbeitung",
  "admin_inactive": "Inaktiv",
  "admin_inbox": "Posteingang",
  "admin_speed_audit": "Geschwindigkeits-Audit",
  "admin_info": "Info",
  "admin_ip_address": "IP-Adresse",
  "admin_joined": "Beigetreten",
  "admin_knowledge_base": "Wissensdatenbank",
  "admin_language": "Sprache",
  "admin_last_activity": "Letzte Aktivität",
  "admin_last_login": "Letzter Login",
  "admin_last_triggered": "Zuletzt ausgelöst",
  "admin_lead_score": "Lead-Bewertung",
  "admin_level": "Stufe",
  "admin_load_failed": "Laden fehlgeschlagen",
  "admin_loading_data": "Daten werden geladen...",
  "admin_low": "Niedrig",
  "admin_medium": "Mittel",
  "admin_messages": "Nachrichten",
  "admin_method": "Methode",
  "admin_monetization": "Monetarisierung",
  "admin_monthly": "Monatlich",
  "admin_name": "Name",
  "admin_next": "Weiter",
  "admin_no": "Nein",
  "admin_no_data_available": "Keine Daten verfügbar",
  "admin_no_experiments": "Keine Experimente gefunden",
  "admin_no_leads": "Keine Leads gefunden",
  "admin_no_prompts": "Keine Prompts gefunden",
  "admin_no_results": "Keine Ergebnisse",
  "admin_no_results_found": "Keine Ergebnisse gefunden",
  "admin_none": "Keine",
  "admin_off": "Aus",
  "admin_on": "An",
  "admin_open_rate": "Öffnungsrate",
  "admin_page_views": "Seitenaufrufe",
  "admin_partner_badges": "Partner-Abzeichen",
  "admin_payload": "Nutzlast",
  "admin_payment_options": "Zahlungsoptionen",
  "admin_platform": "Plattform",
  "admin_platform_audit": "Plattform-Audit",
  "admin_points": "Punkte",
  "admin_portfolio_manager": "Portfolio-Verwaltung",
  "admin_preloader_config": "Vorlade-Konfiguration",
  "admin_preview": "Vorschau",
  "admin_previous": "Zurück",
  "admin_price": "Preis",
  "admin_priority": "Priorität",
  "admin_prompt_name": "Prompt-Name",
  "admin_prompt_text": "Prompt-Text",
  "admin_published": "Veröffentlicht",
  "admin_recipients": "Empfaenger",
  "admin_referral": "Empfehlung",
  "admin_referral_leaderboard": "Empfehlungs-Rangliste",
  "admin_refresh": "Aktualisieren",
  "admin_rejected": "Abgelehnt",
  "admin_remove": "Entfernen",
  "admin_reset": "Zurücksetzen",
  "admin_response_time": "Antwortzeit",
  "admin_restore": "Wiederherstellen",
  "admin_results": "Ergebnisse",
  "admin_retry": "Erneut versuchen",
  "admin_revenue_dashboard": "Umsatz-Dashboard",
  "admin_rista_services": "RisTA-Dienste",
  "admin_role": "Rolle",
  "admin_save_changes": "Änderungen speichern",
  "admin_save_failed": "Speichern fehlgeschlagen",
  "admin_saved_success": "Erfolgreich gespeichert",
  "admin_scheduled": "Geplant",
  "admin_search": "Suchen",
  "admin_select": "Auswählen",
  "admin_select_all": "Alle auswählen",
  "admin_send": "Senden",
  "admin_sent_success": "Erfolgreich gesendet",
  "admin_server_resources": "Server-Ressourcen",
  "admin_service_manager": "Service-Verwaltung",
  "admin_session_duration": "Sitzungsdauer",
  "admin_settings": "Einstellungen",
  "admin_slug": "Slug",
  "admin_social_automation": "Social-Media-Automatisierung",
  "admin_something_wrong": "Etwas ist schiefgelaufen",
  "admin_source": "Quelle",
  "admin_start_date": "Startdatum",
  "admin_subject": "Betreff",
  "admin_submit": "Absenden",
  "admin_subscribers": "Abonnenten",
  "admin_success": "Erfolg",
  "admin_suspended": "Gesperrt",
  "admin_system_prompt": "System-Prompt",
  "admin_tags": "Schlagwörter",
  "admin_template": "Vorlage",
  "admin_templates": "Vorlagen",
  "admin_test_results": "Testergebnisse",
  "admin_tester_program": "Testerprogramm",
  "admin_title": "Titel",
  "admin_total_revenue": "Gesamtumsatz",
  "admin_total_sessions": "Gesamtsitzungen",
  "admin_total_users": "Gesamtbenutzer",
  "admin_trigger": "Auslöser",
  "admin_true": "Wahr",
  "admin_try_again": "Bitte versuchen Sie es erneut",
  "admin_type": "Typ",
  "admin_unique_visitors": "Eindeutige Besucher",
  "admin_unsubscribed": "Abgemeldet",
  "admin_unverified": "Nicht verifiziert",
  "admin_update": "Aktualisieren",
  "admin_updated_success": "Erfolgreich aktualisiert",
  "admin_upload": "Hochladen",
  "admin_urgent": "Dringend",
  "admin_user": "Benutzer",
  "admin_variant_a": "Variante A",
  "admin_variant_b": "Variante B",
  "admin_verified": "Verifiziert",
  "admin_version": "Version",
  "admin_view": "Ansehen",
  "admin_view_details": "Details ansehen",
  "admin_viewer": "Betrachter",
  "admin_warning": "Warnung",
  "admin_webhook_url": "Webhook-URL",
  "admin_weekly": "Wöchentlich",
  "admin_yes": "Ja",
  "admin_analytics_digestadmin_analytics_digest": "Analyse-Zusammenfassung",
  "admin_blog_health": "Blog-Gesundheit",
  "credit_title": "Guthaben",
  "credit_subtitle": "Prepaid-Guthaben für KI-Dienste",
  "credit_available_balance": "Verfügbares Guthaben",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Aufladen",
  "credit_tab_history": "Verlauf",
  "credit_tab_services": "Dienste",
  "credit_tab_crypto": "Krypto",
  "credit_balance_desc": "Ihr Guthaben kann für jeden KI-gestützten Dienst verwendet werden:",
  "credit_bulk_discounts": "Mengenrabatte",
  "credit_add_credits": "Guthaben hinzufügen",
  "credit_select_amount": "Betrag wählen oder benutzerdefinierten Wert eingeben:",
  "credit_bonus": "Bonus",
  "credit_bonus_detail": "Sie erhalten",
  "credit_total_word": "gesamt",
  "credit_method_card": "Karte",
  "credit_method_crypto": "Krypto",
  "credit_processing": "Wird verarbeitet...",
  "credit_add_btn": "Hinzufügen",
  "credit_no_txn": "Noch keine Transaktionen",
  "credit_txn_topup": "Aufladung",
  "credit_txn_promo": "Promo-Guthaben",
  "credit_txn_auto": "Auto-Kauf",
  "credit_txn_purchase": "Kauf",
  "credit_svc_intelligent": "KI-Dienst",
  "credit_svc_available": "Verfügbar",
  "credit_svc_need_more": "Benötigt",
  "credit_svc_more": "mehr",
  "credit_crypto_send": "Senden",
  "credit_crypto_amount": "Betrag:",
  "credit_crypto_equivalent": "Gegenwert",
  "credit_crypto_network": "Netzwerk:",
  "credit_crypto_wallet": "Wallet-Adresse",
  "credit_crypto_confirm": "Guthaben wird nach Bestätigung der Transaktion hinzugefügt.",
  "credit_payment_id": "Zahlungs-ID:",
  "credit_crypto_back": "Zurück zur Krypto-Auswahl",
  "credit_crypto_select_title": "Kryptowährung für Aufladung wählen",
  "credit_crypto_choose_desc": "Wählen Sie eine Kryptowährung. Sie erhalten eine Wallet-Adresse für die Zahlung.",
  "credit_crypto_select_btn": "Wählen",
  "credit_minimum": "Mindestbetrag €5",
  "credit_redirecting": "Weiterleitung...",
  "credit_topup_failed": "Aufladung fehlgeschlagen",
  "credit_crypto_failed": "Krypto-Zahlung konnte nicht gestartet werden",
  "cart_title": "Warenkorb",
  "cart_total": "Gesamt",
  "cart_stripe_checkout": "Stripe-Kasse",
  "cart_credits": "Guthaben",
  "cart_secure_stripe": "Sichere Stripe-Zahlung",
  "cart_insufficient": "Unzureichendes Guthaben. Bitte erst aufladen oder Kartenzahlung wählen.",
  "cart_pay_card": "Mit Karte zahlen",
  "cart_pay_credits_btn": "Mit Guthaben zahlen",
  "cart_clear": "Warenkorb leeren",
  "cart_processing": "Wird verarbeitet...",
  "cart_payment_success": "Zahlung erfolgreich! Ihre Bestellung wird bearbeitet.",
  "cart_complete_setup": "Einrichtung abschließen",
  "cart_also_added": "Kunden mit ähnlichen Käufen wählten auch:",
  "cart_add": "Hinzufügen",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Restguthaben:",
  "cart_checkout_failed": "Bezahlung fehlgeschlagen",
  "cart_checkout_no_session": "Checkout-Sitzung konnte nicht erstellt werden",
  "cart_purchased": "Gekauft",
  "cart_services_with_credits": "Dienst(e) mit Guthaben!",
  "credits_balance_title": "Guthaben-Saldo",
  "credits_topup_btn": "Guthaben aufladen",
  "credits_rate": "1 EUR = 1 Credit",
  "credits_total_topup": "Gesamt aufgeladen",
  "credits_spent_credits": "Ausgegeben (Credits)",
  "credits_spent_payments": "Ausgegeben (Zahlungen)",
  "credits_txn_history": "Transaktionsverlauf",
  "credits_no_txn": "Noch keine Transaktionen",
  "credits_txn_topup": "Aufladung",
  "credits_txn_promo": "Promo-Guthaben",
  "credits_txn_purchase": "Dienstkauf",
  "credits_txn_ai": "KI-Dienst",
  "credits_order_history": "Bestellverlauf",
  "credits_order_label": "Bestellung:",
  "chat_translate_btn": "Ins Englische übersetzen",
  "chat_translating": "Übersetzen...",
  "chat_translated_label": "Englische Übersetzung wird angezeigt. Klicken Sie auf „Original anzeigen\" für die Originalnachrichten.",
  "chat_show_original": "Original anzeigen",
  "chat_show_translated": "Übersetzung anzeigen",
  "pkg_section_badge": "Zeitlich begrenzte Angebote",
  "pkg_section_title": "Starten Sie Ihr Geschäft",
  "pkg_section_title_highlight": "Heute",
  "pkg_section_subtitle": "Premium-Pakete, mit denen Sie blitzschnell online gehen – mit KI-Technologie von Anfang an.",
  "pkg_section_footer": "Alle Preise verstehen sich zzgl. MwSt., falls zutreffend. Sind Sie sich nicht sicher, welches Paket passt? Chatten Sie mit RisTA für eine kostenlose Beratung.",
  "pkg_cta_default": "Loslegen",
  "admin_package_mgr": "Paketmanager",
  "admin_pkg_title": "Landing Page Pakete",
  "admin_pkg_subtitle": "Verwalten Sie hervorgehobene Preispakete, die auf der Landing Page angezeigt werden",
  "admin_pkg_seed": "Standardwerte generieren",
  "admin_pkg_new": "Neues Paket",
  "admin_pkg_create_title": "Neues Paket erstellen",
  "admin_pkg_edit_title": "Paket bearbeiten",
  "admin_pkg_name": "Paketname",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Beschreibung",
  "admin_pkg_price": "Preis",
  "admin_pkg_currency": "Währung",
  "admin_pkg_price_note": "Preishinweis",
  "admin_pkg_badge": "Abzeichen",
  "admin_pkg_accent": "Akzentfarbe",
  "admin_pkg_cta_text": "CTA-Button-Text",
  "admin_pkg_cta_link": "CTA-Link (optional)",
  "admin_pkg_sort": "Sortierreihenfolge",
  "admin_pkg_features": "Funktionen / Enthaltene Leistungen",
  "admin_pkg_add_feature": "Funktion hinzufügen",
  "admin_pkg_highlighted": "Hervorgehoben",
  "admin_pkg_normal": "Normal",
  "admin_pkg_create": "Paket erstellen",
  "admin_pkg_save": "Änderungen speichern",
  "admin_pkg_saving": "Wird gespeichert...",
  "admin_pkg_cancel": "Abbrechen",
  "admin_pkg_empty_title": "Noch keine Pakete konfiguriert",
  "admin_pkg_empty_desc": "Klicken Sie auf Standardwerte generieren, um zwei Starterpakete zu erstellen, oder erstellen Sie Ihr eigenes.",
  "admin_pkg_features_label": "Funktionen",
  "admin_pkg_sort_label": "Sortieren",
  "admin_pkg_delete_confirm": "Dieses Paket löschen? Es wird von der Landing Page entfernt.",
  "admin_pkg_feature_placeholder": "Funktionsbeschreibung...",
  "admin_pkg_pricenote_placeholder": "z.B. Einmalzahlung / +5% Umsatzbeteiligung",
  "admin_pkg_badge_placeholder": "z.B. BESTE WERT",
  "admin_pkg_loading": "Pakete werden geladen...",
  "pkg_qa_have_domain": "Ja, ich habe eine Domain",
  "pkg_qa_need_domain": "Ich brauche eine Domain",
  "pkg_qa_describe_biz": "Lassen Sie mich mein Unternehmen beschreiben",
  "pkg_qa_more_info": "Erzählen Sie mir mehr über dieses Paket",
  "sp_managed_hosting": "Managed Hosting",
  "sp_managed_hosting_desc": "Vollständig verwaltetes Hosting mit Überwachung und Support.",
  "sp_enterprise_ad": "Enterprise-Werbung",
  "sp_enterprise_ad_desc": "Groß angelegte Werbekampagnen mit dedizierter Strategie.",
  "sp_email_marketing": "E-Mail-Marketing-Setup",
  "sp_email_marketing_desc": "Professionelle E-Mail-Sequenzen und Marketing-Automatisierung.",
  "sp_competitor_analysis": "Wettbewerbsanalyse-Bericht",
  "sp_competitor_analysis_desc": "Marktintelligenz und Wettbewerbspositionierung.",
  "sp_website_audit": "Website-Audit & SEO-Bericht",
  "sp_website_audit_desc": "Umfassende Website-Analyse mit umsetzbaren Empfehlungen.",
  "sp_managed_trading": "Verwalteter Handel",
  "sp_managed_trading_desc": "Expertenverwalteter Handel mit bewährten Strategien.",
  "sp_trading_consult": "Handelsberatung",
  "sp_trading_consult_desc": "Individuelle Handelsstrategieberatung.",
  "sp_domains": "LiveDomain Aftermarket",
  "sp_domains_desc": "Premium-Domain-Akquisition und Aftermarket-Deals.",
  "sp_domain_mgmt": "Domain-Verwaltung",
  "sp_domain_mgmt_desc": "DNS-Verwaltung, Verlängerungen und Transfers.",
  "sp_defi": "DeFi-Lösungen",
  "sp_defi_desc": "Smart Contracts, Yield Farming und Liquiditätspools.",
  "sp_personal_brand": "Personal Branding",
  "sp_personal_brand_desc": "Aufbau Ihrer Online-Präsenz und Markenidentität.",
  "sp_ad_gen": "Ad-Generator",
  "sp_ad_gen_desc": "Erstellen Sie sofort hochkonvertierende Werbetexte.",
  "sp_priority": "Prioritätswarteschlange",
  "sp_priority_desc": "Garantierte Antwort innerhalb von 4 Stunden.",
  "sp_maintenance": "Wartungsplan",
  "sp_maintenance_desc": "Laufende Wartung, Updates und technischer Support.",
  "sp_consulting": "Smarte Beratung",
  "sp_consulting_desc": "Einzelberatung mit unseren Smart-Technologie-Experten.",
  "sp_market_snapshot": "Marktübersicht",
  "sp_market_snapshot_desc": "Schneller Überblick über Ihre Marktlandschaft.",
  "sp_trend_explainer": "Trend-Erklärer",
  "sp_trend_explainer_desc": "Verstehen Sie aufkommende Trends in Ihrer Branche.",
  "sp_competitor_qa": "Wettbewerber-Fragen",
  "sp_competitor_qa_desc": "Antworten über die Strategien Ihrer Wettbewerber.",
  "sp_country_entry": "Ländereintritts-Check",
  "sp_country_entry_desc": "Bewertung der Marktreife für internationale Expansion.",
  "sp_vendor_shortlist": "Anbieter-Shortlist",
  "sp_vendor_shortlist_desc": "Kuratierte Anbieterliste für Ihre Bedürfnisse.",
  "sp_tam_logic": "TAM-Logik-Skizze",
  "sp_tam_logic_desc": "Marktgrößenschätzung mit Logik-Aufschlüsselung.",
  "sp_positioning": "Positionierungsanalyse",
  "sp_positioning_desc": "Produkt- und Zielgruppen-Positionierungsstrategie.",
  "sp_addon_title": "Add-ons & Support",
  "sp_addon_desc": "Stärken Sie Ihr Projekt mit Priority-Support und Expertenberatung.",
  "sp_research_title": "Smarte Forschungsprodukte",
  "sp_research_desc": "On-Demand-Marktintelligenz und smarte Analysetools.",
  "tier_section_badge": "Smarte Pakete",
  "tier_section_title": "Wählen Sie Ihren",
  "tier_section_highlight": "Wachstumsplan",
  "tier_section_subtitle": "Gebündelte Pakete für maximalen Mehrwert. Wählen Sie die passende Stufe.",
  "tier_one_time": "Einmalig",
  "tier_monthly": "Monatlich",
  "tier_section_footer": "Alle Preise verstehen sich zzgl. MwSt. Brauchen Sie ein individuelles Paket? Chatten Sie mit RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfekt für den Start Ihrer digitalen Präsenz",
  "tier_tag_growth": "Skalieren Sie Ihr Geschäft mit smarten Tools und Marketing",
  "tier_tag_pro": "Full-Stack digitales Wachstum für ernsthafte Unternehmen",
  "tier_tag_enterprise": "Komplette digitale Transformation für Ihr Unternehmen",
  "tier_cta_starter": "Starter holen",
  "tier_cta_growth": "Growth holen",
  "tier_cta_pro": "Pro holen",
  "tier_cta_enterprise": "Enterprise holen",
  "tier_badge_popular": "BELIEBT",
  "tier_badge_best": "BESTER WERT",
  "tier_badge_all": "ALL-IN-ONE",
  "tier_per_mo": "Mt.",
  "tier_once_label": "einmalig",
  "tier_or_monthly": "oder",
  "tier_f_starter_1": "Smarter Businessplan-Generator",
  "tier_f_starter_2": "Smarter Lebenslauf-Builder (3 Stk.)",
  "tier_f_starter_3": "Website-Audit & SEO-Bericht",
  "tier_f_starter_4": "Smartes Logo- und Marken-Kit",
  "tier_f_starter_5": "Marktübersicht-Bericht",
  "tier_f_starter_6": "FAQ-Antwort-Entwurf",
  "tier_f_starter_7": "Blog-Gliederung aus Trend",
  "tier_f_starter_8": "E-Mail-Support innerhalb 48h",
  "tier_f_growth_1": "Alles aus Starter",
  "tier_f_growth_2": "Smarte E-Mail-Kampagne",
  "tier_f_growth_3": "Social-Media-Kalender & Analyse (3 Mo.)",
  "tier_f_growth_4": "Wettbewerbsanalyse-Bericht",
  "tier_f_growth_5": "Ad-Generator (5 Kampagnen)",
  "tier_f_growth_6": "Outreach-E-Mail-Generator",
  "tier_f_growth_7": "Trend-Erklärer",
  "tier_f_growth_8": "Positionierungsanalyse",
  "tier_f_growth_9": "Prioritäts-E-Mail-Support innerhalb 24h",
  "tier_f_pro_1": "Alles aus Growth",
  "tier_f_pro_2": "SEO & Digital Marketing Setup",
  "tier_f_pro_3": "E-Mail-Marketing-Setup",
  "tier_f_pro_4": "Smarter Video-Script-Writer (5 Stk.)",
  "tier_f_pro_5": "Schnelle TAM-Logik-Skizze",
  "tier_f_pro_6": "Risiko-Checkliste",
  "tier_f_pro_7": "Feature-Priorisierung",
  "tier_f_pro_8": "Anbieter-Shortlist-Entwurf",
  "tier_f_pro_9": "Smarte Beratungssitzung (2 Std.)",
  "tier_f_pro_10": "Prioritätssupport innerhalb 12h",
  "tier_f_ent_1": "Alles aus Pro",
  "tier_f_ent_2": "Individuelle Softwareentwicklung",
  "tier_f_ent_3": "Enterprise-Werbestrategie",
  "tier_f_ent_4": "Managed Hosting (12 Monate)",
  "tier_f_ent_5": "Wartungsplan (6 Monate)",
  "tier_f_ent_6": "Smarte Beratung (10 Std.)",
  "tier_f_ent_7": "Ländereintritts-Check",
  "tier_f_ent_8": "Executive Summary für Folien",
  "tier_f_ent_9": "JTBD-Problemstellung",
  "tier_f_ent_10": "Dedizierter Account-Manager",
  "tier_f_ent_11": "Prioritätswarteschlange (4h Antwort)",
  "calc_title": "Preisrechner",
  "calc_subtitle": "Vergleichen Sie einzelne Dienste mit gebündelten Paketen.",
  "calc_badge": "Mehr sparen",
  "calc_select_services": "Dienste auswählen",
  "calc_search_placeholder": "Dienste suchen...",
  "calc_selected": "ausgewählt",
  "calc_your_selection": "Ihre Auswahl",
  "calc_individual_total": "Einzelsumme",
  "calc_best_tier": "Bestes passendes Paket",
  "calc_you_save": "Sie sparen",
  "calc_no_services": "Wählen Sie Dienste aus, um Einsparungen zu sehen",
  "calc_clear_all": "Alle löschen",
  "calc_get_tier": "Dieses Paket holen",
  "calc_individual_cheaper": "Einzeldienste sind für Ihre Auswahl bereits kosteneffizient. Fügen Sie weitere hinzu!",
  "referred_by": "Empfohlen von",
  "referral_signup_reward": "Registrieren Sie sich, um Ihr Konto mit dieser Empfehlung zu verbinden.",
  "badge_coming_soon": "Bald verfügbar",
  "badge_available_soon": "Demnächst verfügbar",
  "badge_from_price": "ab",
  "badge_preparing": "Wir bereiten diesen Service für Sie vor",
  "svc_managed-hosting_label": "Managed Hosting",
  "svc_managed-hosting_desc": "Vollständig verwaltetes Hosting mit Überwachung und Support",
  "svc_enterprise-advertising_label": "Unternehmenswerbung",
  "svc_enterprise-advertising_desc": "Groß angelegte Werbekampagnen mit dedizierter Strategie",
  "svc_email-marketing_label": "E-Mail-Marketing-Einrichtung",
  "svc_email-marketing_desc": "Professionelle E-Mail-Sequenzen, Vorlagen und Automatisierung",
  "svc_competitor-analysis_label": "Wettbewerbsanalyse-Bericht",
  "svc_competitor-analysis_desc": "Marktintelligenz und Wettbewerbspositionierung",
  "svc_legal-docs_label": "Rechtsdokument-Generator",
  "svc_legal-docs_desc": "NDA, Verträge, AGB-Vorlagen",
  "svc_website-audit_label": "Website-Audit & SEO-Bericht",
  "svc_website-audit_desc": "Umfassende Website-Analyse mit umsetzbaren Empfehlungen",
  "svc_trading-consultation_label": "Handelsberatung",
  "svc_trading-consultation_desc": "Expertengeführte Handelsstrategiesitzungen",
  "svc_managed-trading_label": "Verwalteter Handel",
  "svc_managed-trading_desc": "Von Experten verwalteter Handel mit bewährten Strategien",
  "svc_domain-management_label": "Domainverwaltung",
  "svc_domain-management_desc": "Domainregistrierung, DNS-Verwaltung und Transfers",
  "svc_personal-branding_label": "Persönliches Branding",
  "svc_personal-branding_desc": "Bauen Sie Ihre Online-Präsenz und persönliche Marke auf",
  "admin_escalation_alert": "Chat-Eskalation",
  "admin_view_escalations": "Eskalationswarteschlange anzeigen",
  "from": "Ab",
  "vector_gen_title": "Smarter Vektor",
  "vector_gen_title_hl": "Generator",
  "vector_gen_badge": "Smartes Vektor-Studio",
  "vector_gen_desc": "Beschreiben Sie Ihre Idee, laden Sie Referenzen hoch und erhalten Sie in Sekunden eine produktionsreife SVG-Vektorgrafik.",
  "vector_gen_balance": "Ihr Guthaben",
  "vector_gen_per_gen": "Credits pro Generierung",
  "vector_gen_prompt_label": "Beschreiben Sie Ihre Vektorgrafik",
  "vector_gen_prompt_ph": "z.B. Ein minimalistisches Berglogo mit Sonnenstrahlen in Blaugrün und Orange...",
  "vector_gen_style": "Stil",
  "vector_gen_color": "Farbmodus",
  "vector_gen_refs": "Referenzdateien",
  "vector_gen_optional": "optional, max. 3",
  "vector_gen_upload": "Referenz hochladen (PNG, JPG, SVG)",
  "vector_gen_generating": "Wird generiert...",
  "vector_gen_cta": "Vektor generieren",
  "vector_gen_result": "Ihre Vektorgrafik",
  "vector_gen_model_used": "Modell",
  "vector_gen_history": "Generierungsverlauf",
  "vector_gen_no_history": "Noch keine Generierungen",
  "vector_gen_login_req": "Bitte melden Sie sich an, um den Vektor-Generator zu nutzen.",
  "vector_gen_service_title": "Professionelle Vektoren benötigt?",
  "vector_gen_service_desc": "Bestellen Sie maßgeschneiderte Vektorgrafiken als Designservice mit Überarbeitungen und Markenrichtlinien.",
  "vector_gen_service_cta": "Design-Services ansehen",
  "vector_gen_product_type": "Produkttyp",
  "vector_gen_size": "Ausgabegröße",
  "vector_gen_error_prompt": "Bitte beschreiben Sie Ihre Vektorgrafik-Idee.",
  "admin_vector_gen": "Vektor-Generator",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Landingpage",
  "admin_landing_text": "Landingpage Texte",
  "admin_vector_title": "Vektor-Generator",
  "admin_vector_models": "Verfügbare Modelle",
  "admin_vector_pricing": "Preise & Limits",
  "svc_vector-generator_label": "Smarter Vektor-Generator",
  "svc_vector-generator_desc": "Produktionsreife SVG-Vektorgrafiken aus Textbeschreibungen generieren",
  "sp_vector_gen_name": "Smarter Vektor-Generator",
  "sp_vector_gen_desc": "Produktionsreife SVG-Vektorgrafiken aus Textbeschreibungen per KI generieren.",
  "sp_vector_gen_feat": "Text-zu-Vektor-Generierung|SVG- & PNG-Export|Mehrere Stilvorlagen|Inline-SVG-Editor|Referenzdatei-Upload|Kreditbasierte Preise",
  "sp_managed_hosting_name": "Managed Hosting",
  "sp_managed_hosting_feat": "24/7-Überwachung|Automatische Updates|SSL-Verwaltung|Tägliche Backups|Performance-Optimierung|Dedizierter Support",
  "sp_enterprise_ad_name": "Enterprise-Werbung",
  "sp_enterprise_ad_feat": "Kampagnenstrategie|Multi-Channel|A/B-Tests|Performance-Tracking|Dedizierter Manager|Reports",
  "sp_email_marketing_name": "E-Mail-Marketing-Setup",
  "sp_email_marketing_feat": "E-Mail-Sequenzen|Template-Design|Automatisierung|Listenverwaltung|Analysen|A/B-Tests",
  "sp_competitor_analysis_name": "Konkurrenzanalyse-Bericht",
  "sp_competitor_analysis_feat": "Marktanalyse|Konkurrenzprofilierung|SWOT|Preisvergleich|Empfehlungen|Updates",
  "sp_website_audit_name": "Website-Audit & SEO-Bericht",
  "sp_website_audit_feat": "Technisches Audit|SEO-Analyse|Leistungsmetriken|Barrierefreiheit|Sicherheitsscan|Aktionsplan",
  "sp_defi_name": "DeFi-Lösungen",
  "sp_defi_feat": "Smart Contracts|Yield Farming|Liquiditätspools|DeFi-Audit|Token-Erstellung|Staking-Lösungen",
  "sp_personal_brand_name": "Persönliches Branding",
  "sp_personal_brand_feat": "Markenstrategie|Social-Media-Präsenz|Persönliche Website|Inhaltsplanung|Professionelle Fotos|Bio-Texte",
  "sp_ad_gen_name": "Anzeigen-Generator",
  "sp_ad_gen_feat": "Anzeigentexte|Kreativformate|Multi-Plattform|A/B-Varianten|Zielgruppen-Targeting|Performance-Tipps",
  "sp_priority_name": "Prioritätswarteschlange",
  "sp_priority_feat": "4-Stunden-Antwort|Dedizierter Kanal|Prioritätsbearbeitung|Status-Updates|SLA-Garantie|Erweiterte Unterstützung",
  "sp_maintenance_name": "Wartungsplan",
  "sp_maintenance_feat": "Monatliche Updates|Sicherheitspatches|Performance-Überwachung|Fehlerbehebung|Verfügbarkeitsgarantie|Prioritäts-Support",
  "sp_consulting_name": "Smarte Beratungssitzung",
  "sp_consulting_feat": "Expertenberatung|Strategiesitzung|Technische Beratung|Umsetzungsplan|Nachbereitung|Aufzeichnung inklusive",
  "sp_market_snapshot_name": "Marktüberblick",
  "sp_market_snapshot_feat": "Marktüberblick|Wichtige Trends|Wettbewerbslandschaft|Wachstumschancen|Risikofaktoren|Executive Summary",
  "sp_trend_explainer_name": "Trend-Erklärer",
  "sp_trend_explainer_feat": "Trendanalyse|Branchenwirkung|Chancenbewertung|Zeitprojektion|Handlungsschritte|Visueller Bericht",
  "sp_competitor_qa_name": "Wettbewerber-Fragen",
  "sp_competitor_qa_feat": "Strategieanalyse|Preiseinblicke|Marktpositionierung|Feature-Vergleich|Schwächenanalyse|Chancenkarte",
  "sp_country_entry_name": "Markteintritts-Check",
  "sp_country_entry_feat": "Marktbereitschaft|Regulierungsüberblick|Kulturelle Faktoren|Wettbewerbsanalyse|Eintrittsstrategie|Risikobewertung",
  "sp_vendor_shortlist_name": "Anbieter-Shortlist",
  "sp_vendor_shortlist_feat": "Anbieterrecherche|Vergleichsmatrix|Preisanalyse|Fähigkeitsbewertung|Empfehlungen|Kontaktdaten",
  "sp_tam_logic_name": "TAM-Logik-Skizze",
  "sp_tam_logic_feat": "TAM-Schätzung|SAM/SOM-Aufschlüsselung|Logik-Framework|Datenquellen|Wachstumsannahmen|Visuelle Darstellung",
  "sp_positioning_name": "Positionierungswinkel",
  "sp_positioning_feat": "Marktpositionierung|Zielgruppensegmentierung|Wertversprechen|Messaging-Framework|Differenzierung|Wettbewerbsvorteil",
  "sp_managed_trading_name": "Verwaltetes Trading",
  "sp_managed_trading_feat": "Experten-Portfoliomanagement|Risikomanagement|Bewährte Strategien|Regelmäßige Berichte|Dedizierter Manager|Marktanalyse",
  "sp_trading_consult_name": "Trading-Beratung",
  "sp_trading_consult_feat": "Einzelsitzungen|Strategieentwicklung|Marktanalyse|Risikobewertung|Portfolio-Review|Expertenberatung",
  "sp_domains_name": "LiveDomain-Nachmarkt",
  "sp_domains_feat": "Premium-Domains|Nachmarkt-Deals|Domain-Bewertung|Transfer-Support|Verhandlung|Portfolio-Verwaltung",
  "sp_domain_mgmt_name": "Domain-Verwaltung",
  "sp_domain_mgmt_feat": "DNS-Verwaltung|Auto-Verlängerung|Transfer-Support|Portfolio-Tracking|SSL-Zertifikate|Whois-Datenschutz",
  "vector_gen_model": "Modell",
  "vector_gen_quality": "Qualitätsstufe",
  "svc_smart-resume_label": "Smarter Lebenslauf-Ersteller",
  "svc_smart-resume_desc": "ATS-optimierte Lebensläufe, erstellt durch unsere KI",
  "svc_smart-business-plan_label": "Smarter Businessplan-Generator",
  "svc_smart-business-plan_desc": "Vollständiger Businessplan mit Finanzen und Marktanalyse",
  "svc_smart-seo-report_label": "Smarter SEO-Bericht",
  "svc_smart-seo-report_desc": "Automatisierte Website-Analyse mit umsetzbaren Empfehlungen",
  "svc_smart-brand-kit_label": "Smartes Logo und Brand Kit",
  "svc_smart-brand-kit_desc": "Logo-Konzept, Farbpalette, Typografie und Social-Media-Assets",
  "svc_smart-email-campaign_label": "Smarte E-Mail-Kampagne",
  "svc_smart-email-campaign_desc": "KI-gestütztes E-Mail-Marketing mit optimierten Sequenzen",
  "svc_smart-social-calendar_label": "Social-Media-Kalender & Analyse",
  "svc_smart-social-calendar_desc": "30 Tage smart generierte Beiträge mit Engagement-Strategie",
  "svc_ad-generator_label": "Anzeigen-Generator",
  "svc_ad-generator_desc": "Hochkonvertierende Anzeigentexte und Kreativmaterial sofort generieren",
  "svc_smart-translation_label": "Smarte Übersetzungsdienste",
  "svc_smart-translation_desc": "Professionelle Dokumentenübersetzung in 50+ Sprachen",
  "svc_smart-video-script_label": "Smarter Videoskript-Autor",
  "svc_smart-video-script_desc": "YouTube-, TikTok- und Werbeskripte für maximales Engagement",
  "svc_priority-queue_label": "Prioritätswarteschlange",
  "svc_priority-queue_desc": "Garantierte Antwort innerhalb von 4 Stunden",
  "svc_maintenance-plan_label": "Wartungsplan",
  "svc_maintenance-plan_desc": "Laufende Wartung, Updates und technischer Support",
  "svc_smart-consulting_label": "Smarte Beratungssitzung",
  "svc_smart-consulting_desc": "Einzelberatung mit unseren Technologieexperten",
  "svc_market-snapshot_label": "Marktüberblick",
  "svc_market-snapshot_desc": "Schneller Überblick über Ihre Marktlandschaft",
  "svc_trend-explainer_label": "Trend-Erklärer",
  "svc_trend-explainer_desc": "Verstehen Sie aufkommende Trends in Ihrer Branche",
  "svc_competitor-qa_label": "Wettbewerber-Fragen",
  "svc_competitor-qa_desc": "Antworten über die Strategien Ihrer Wettbewerber",
  "svc_country-entry-check_label": "Markteintritts-Check",
  "svc_country-entry-check_desc": "Bewertung der Marktbereitschaft für internationale Expansion",
  "svc_should-i-care_label": "Relevanz-Check",
  "svc_should-i-care_desc": "Bewerten Sie, ob ein Trend für Ihr Geschäft wichtig ist",
  "svc_report-matchmaker_label": "Berichts-Vermittler",
  "svc_report-matchmaker_desc": "Finden Sie den richtigen Forschungsbericht",
  "svc_which-region-first_label": "Regionale Priorität",
  "svc_which-region-first_desc": "Datengestützte Empfehlung für regionalen Markteintritt",
  "svc_vendor-shortlist_label": "Anbieter-Shortlist",
  "svc_vendor-shortlist_desc": "Kuratierte Anbieterliste für Ihre Bedürfnisse",
  "svc_forecast-explanation_label": "Prognose-Erklärung",
  "svc_forecast-explanation_desc": "Klare Erklärung von Marktprognosen",
  "svc_outreach-email-gen_label": "Outreach-E-Mail-Generator",
  "svc_outreach-email-gen_desc": "Personalisierte Outreach-E-Mails im großen Stil",
  "svc_executive-summary_label": "Executive Summary",
  "svc_executive-summary_desc": "Präsentationsfertige Zusammenfassungen",
  "svc_faq-answer-draft_label": "FAQ-Antwort-Entwurf",
  "svc_faq-answer-draft_desc": "Antworten für häufig gestellte Kundenfragen",
  "svc_jtbd-problem_label": "JTBD-Problemstellung",
  "svc_jtbd-problem_desc": "Jobs-to-be-done Framework Problemanalyse",
  "svc_tam-logic-sketch_label": "TAM-Logik-Skizze",
  "svc_tam-logic-sketch_desc": "Gesamtmarkt-Schätzung mit logischer Aufschlüsselung",
  "svc_risk-checklist_label": "Risiko-Checkliste",
  "svc_risk-checklist_desc": "Umfassende Risikobewertungs-Checkliste",
  "svc_feature-prioritization_label": "Feature-Priorisierung",
  "svc_feature-prioritization_desc": "Datengestützte Empfehlungen zur Feature-Priorisierung",
  "svc_next-research-question_label": "Nächste Forschungsfrage",
  "svc_next-research-question_desc": "Entdecken Sie die nächste wichtige Forschungsfrage",
  "svc_positioning-angle_label": "Positionierungswinkel",
  "svc_positioning-angle_desc": "Produkt- und Zielgruppen-Positionierungsanalyse",
  "svc_blog-outline-trend_label": "Blog-Gliederung aus Trend",
  "svc_blog-outline-trend_desc": "Trendthemen in strukturierte Blog-Gliederungen verwandeln",
  "admin_ai_reports": "KI-Service-Berichte",
  "admin_project_delivery": "Projektlieferung",
  "admin_analytics_digest": "Analyse-Zusammenfassung",
  "admin_seo_suggestions": "SEO-Optimierung",
  "admin_visitor_map": "Besucherkarte",
  "admin_competitor_monitor": "Wettbewerbsanalyse",
  "admin_email_workflows": "E-Mail-Workflows",
  "admin_collab_editing": "Team-Zusammenarbeit",
  "admin_status_online": "Online",
  "admin_status_offline": "Offline",
  "admin_status_online_desc": "Sie sind als online sichtbar. Nutzer, die eine Eskalation anfordern, werden mit Ihnen verbunden.",
  "admin_status_offline_desc": "Sie sind offline. Nutzer, die eine Eskalation anfordern, werden gebeten, es später zu versuchen.",
  "admin_ai_model": "KI-Modell",
  "admin_prompts": "Prompts",
  "admin_no_escalations": "Keine Eskalationen in der Warteschlange.",
  "blog_edit": "Beitrag bearbeiten",
  "admin_card_visibility": "Karten-Sichtbarkeit",
  "agency_rista_tooltip": "Mit RisTA chatten",
  "agency_hero_title_1": "Blitzschnelle Websites, die ",
  "agency_hero_title_highlight": "verkaufen",
  "agency_hero_title_2": " für lokale Unternehmen",
  "agency_hero_subtitle_1": "Erhalten Sie eine maßgeschneiderte Website, die in Millisekunden lädt – inklusive integrierter Analysen für",
  "agency_hero_subtitle_2": ". Keine langsamen Seiten, mehr Leads — Start in wenigen Wochen.",
  "agency_hero_limited": "Begrenzte Plätze!",
  "agency_hero_cta_pricing": "€498 Paket ansehen",
  "agency_hero_cta_audit": "Kostenloses Audit",
  "agency_trust_maintenance": "Wartung danach",
  "agency_trust_efficient": "100% Effizient",
  "agency_trust_powered": "KI-gestützt",
  "agency_speed_title": "Website-Ladegeschwindigkeit",
  "agency_speed_before": "Vorher",
  "agency_speed_after": "Nachher",
  "agency_speed_leads": "+35% Leads",
  "agency_pain_title_1": "Langsame Websites ",
  "agency_pain_title_2": "vernichten Umsätze",
  "agency_pain_subtitle": "Jede Sekunde Ladezeit kostet Sie Kunden. Das ist das Problem – und so lösen wir es.",
  "agency_pain_slow_title": "Langsames Laden = Verlorene Leads",
  "agency_pain_slow_desc": "Ihre Website braucht über 5 Sekunden zum Laden. Besucher sind weg, bevor sie Ihr Angebot sehen. Sie zahlen für Traffic, der nie konvertiert.",
  "agency_pain_stats_title": "47% verlassen bei >3s",
  "agency_pain_stats_desc": "Google-Forschung zeigt, dass fast die Hälfte der Besucher eine mobile Website verlässt, die länger als 3 Sekunden zum Laden braucht.",
  "agency_pain_stats_source": "Quelle: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Unsere Speed-First-Technologie",
  "agency_pain_solution_desc": "Maßgeschneiderte Websites, optimiert für Ladezeiten unter 1 Sekunde. Edge-gecacht, bildoptimiert, code-minimiert. Mehr Speed = mehr Leads = mehr Umsatz.",
  "agency_pricing_title": "Einfache, transparente Preise",
  "agency_pricing_subtitle": "Wählen Sie den Plan, der zu Ihrem Unternehmen passt. Alle Pakete nutzen unsere Speed-First-Technologie.",
  "agency_pricing_urgency_1": "Nur noch ",
  "agency_pricing_urgency_2": " Starter-Plätze diesen Monat",
  "agency_pricing_popular": "BELIEBTESTE",
  "agency_pricing_get_started": "Jetzt starten",
  "agency_pricing_guarantee": "30-Tage-Geld-zurück-Garantie",
  "agency_pricing_ideal": "Ideal für:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "einmalig",
  "agency_pricing_starter_ideal": "Einzelunternehmer",
  "agency_pricing_s_1": "Blitzschnelle individuelle Website",
  "agency_pricing_s_2": "Domain + Hosting für 1 Jahr",
  "agency_pricing_s_3": "Basis-Analyse-Dashboard",
  "agency_pricing_s_4": "Mobilfähiges Design",
  "agency_pricing_s_5": "SSL-Zertifikat inklusive",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Wachsende Shops",
  "agency_pricing_p_1": "Alles aus Starter",
  "agency_pricing_p_2": "E-Commerce + Warenkorbrettung",
  "agency_pricing_p_3": "SEO-Optimierungspaket",
  "agency_pricing_p_4": "A/B-Testing Integration",
  "agency_pricing_p_5": "Prioritäts-Support",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Skalierende Unternehmen",
  "agency_pricing_pr_1": "Alles aus Performance",
  "agency_pricing_pr_2": "Google Ads Management",
  "agency_pricing_pr_3": "Wöchentliche Performance-Audits",
  "agency_pricing_pr_4": "Dedizierter Account-Manager",
  "agency_pricing_pr_5": "Individuelle Integrationen",
  "agency_social_title": "Vertraut von lokalen Unternehmen",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Ich analysiere das Besucherverhalten in Echtzeit, um Ihre Conversions zu steigern.",
  "agency_social_see_clients": "Was unsere Kunden sagen",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Lokaler Shop",
  "agency_social_t1_text": "Unsere Leads haben sich im ersten Monat verdoppelt! Die Website lädt sofort und unsere Kunden lieben das neue Design.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Restaurantbesitzerin",
  "agency_social_t2_text": "Unsere Online-Bestellungen stiegen nach dem Start der neuen Website um 40%. Der Geschwindigkeitsunterschied ist wie Tag und Nacht.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Fitnessstudio",
  "agency_social_t3_text": "Professionell, schnell und sie halten ihre Versprechen. Unsere Buchungsrate stieg in nur 3 Wochen um 35%.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Boutique-Besitzerin",
  "agency_social_t4_text": "Die E-Commerce-Einrichtung war nahtlos. Die Warenkorbrettung allein hat den Performance-Plan im ersten Quartal bezahlt.",
  "agency_social_metric_1": "Durchschn. Ladezeit",
  "agency_social_metric_2": "Mehr Leads",
  "agency_social_metric_3": "Kundenzufriedenheit",
  "agency_services_title": "Alles, was Ihr Unternehmen braucht",
  "agency_services_subtitle": "Umfassende digitale Lösungen für Ihre Online-Präsenz.",
  "agency_svc_fast_title": "Schnelle Websites",
  "agency_svc_fast_desc": "Maßgeschneiderte Websites unter 1 Sekunde Ladezeit. Mobile-First, SEO-optimiert, conversion-fokussiert.",
  "agency_svc_ecom_title": "E-Commerce Shops",
  "agency_svc_ecom_desc": "Online verkaufen mit Warenkorbrettung, Zahlungsabwicklung und Bestandsverwaltung.",
  "agency_svc_seo_title": "SEO Audit & Optimierung",
  "agency_svc_seo_desc": "Höher bei Google ranken. Technisches SEO, Content-Strategie und monatliche Performance-Berichte.",
  "agency_svc_ads_title": "Google Ads Einrichtung",
  "agency_svc_ads_desc": "Schnell gezielten Traffic erhalten. Kampagneneinrichtung, Optimierung und ROI-Tracking inklusive.",
  "agency_svc_maint_title": "Wartung & Support",
  "agency_svc_maint_desc": "Hosting, Sicherheitsupdates, Backups und Inhaltsänderungen. Ab €30/Monat.",
  "agency_faq_title": "Häufig gestellte Fragen",
  "agency_faq_q1": "Wie schnell wird meine Website laden?",
  "agency_faq_a1": "Unter 1 Sekunde. Wir optimieren jede Millisekunde — von der Serverantwort bis zum vollständigen visuellen Rendering.",
  "agency_faq_q2": "Was ist im €498 Starter-Paket enthalten?",
  "agency_faq_a2": "Eine blitzschnelle individuelle Website, Domain und Hosting für 1 Jahr, Basis-Analyse-Dashboard, mobilfähiges Design und SSL-Zertifikat.",
  "agency_faq_q3": "Wie lange dauert es bis zum Start?",
  "agency_faq_a3": "Die meisten Starter-Projekte starten in 2-3 Wochen. Performance- und Premium-Pläne dauern je nach Komplexität 4-6 Wochen.",
  "agency_faq_q4": "Bieten Sie laufende Wartung an?",
  "agency_faq_a4": "Ja. Nach dem ersten Jahr beginnt die Wartung bei €30/Monat, einschließlich Hosting, Sicherheitsupdates, Backups und kleinerer Inhaltsänderungen.",
  "agency_faq_q5": "Kann ich meinen Plan später upgraden?",
  "agency_faq_a5": "Absolut. Sie können jederzeit von Starter auf Performance oder Premium upgraden. Wir rechnen Ihre anfängliche Investition an.",
  "agency_cta_title_1": "Bereit zu skalieren ",
  "agency_cta_title_2": "ohne Grenzen?",
  "agency_cta_subtitle": "Erzählen Sie uns von Ihrem Unternehmen – wir erstellen einen maßgeschneiderten Plan für Ihre Online-Präsenz. Kostenlose Beratung, unverbindlich.",
  "agency_contact_name": "Ihr Name",
  "agency_contact_email": "E-Mail-Adresse",
  "agency_contact_biz_select": "Unternehmensart wählen",
  "agency_contact_biz_restaurant": "Restaurant / Gastronomie",
  "agency_contact_biz_retail": "Einzelhandel / Geschäft",
  "agency_contact_biz_services": "Professionelle Dienstleistungen",
  "agency_contact_biz_fitness": "Fitness / Wellness",
  "agency_contact_biz_realestate": "Immobilien",
  "agency_contact_biz_other": "Sonstiges",
  "agency_contact_submit": "Kostenlose Beratung anfordern",
  "agency_contact_sent_title": "Nachricht gesendet!",
  "agency_contact_sent_desc": "Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
  "agency_exit_title": "Warten! Kostenloses Speed-Audit?",
  "agency_exit_desc": "Finden Sie heraus, wie viel schneller Ihre Website sein könnte. Erhalten Sie einen detaillierten Performance-Bericht — 100% kostenlos.",
  "agency_exit_email": "Ihre E-Mail",
  "agency_exit_submit": "Audit senden",
  "agency_exit_thanks_title": "Vielen Dank!",
  "agency_exit_thanks_desc": "Wir senden Ihnen Ihr kostenloses Speed-Audit innerhalb von 24 Stunden.",
  "agency_footer_brand_desc": "Entwickelt, gehostet und gestaltet von Infinitybusiness.org",
  "agency_footer_services": "Dienstleistungen",
  "agency_footer_fast_web": "Schnelle Websites",
  "agency_footer_ecom": "E-Commerce Shops",
  "agency_footer_seo": "SEO Audit",
  "agency_footer_ads": "Google Ads Einrichtung",
  "agency_footer_maint": "Wartung",
  "agency_footer_company": "Unternehmen",
  "agency_footer_about": "Über uns",
  "agency_footer_contact": "Kontakt",
  "agency_footer_privacy": "Datenschutz",
  "agency_footer_terms": "AGB",
  "agency_footer_touch": "Kontaktieren Sie uns",
  "agency_footer_copyright": "© 2026 Infinity Business. Alle Rechte vorbehalten.",
  "agency_footer_dev_by": "Entwickelt, gehostet und gestaltet von",
  "agency_footer_newsletter": "Newsletter abonnieren",
  "agency_footer_subscribe": "Abonnieren",
  "agency_sticky_pricing": "Preise ansehen",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Entdecken Sie unser Portfolio an Website-Transformationen. Vorher-Nachher-Vergleiche realer Kundenprojekte.",
  "showroom_badge": "Unsere Arbeit",
  "showroom_title_prefix": "Projekt",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Erleben Sie echte Transformationen. Ziehen Sie den Schieberegler, um den Vorher-Nachher-Vergleich unserer Kundenprojekte zu sehen.",
  "showroom_search_placeholder": "Projekte suchen...",
  "showroom_all_services": "Alle Dienste",
  "showroom_sort_newest": "Neueste zuerst",
  "showroom_sort_oldest": "Älteste zuerst",
  "showroom_sort_name_az": "Name A-Z",
  "showroom_sort_name_za": "Name Z-A",
  "showroom_active_filters": "Aktive Filter",
  "showroom_showing": "Anzeige",
  "showroom_project_singular": "Projekt",
  "showroom_project_plural": "Projekte",
  "showroom_empty": "Noch keine Projekte im Showroom.",
  "showroom_no_match": "Keine Projekte entsprechen Ihren Filtern.",
  "showroom_features_built": "Erstellte Funktionen",
  "showroom_visit_live": "Live-Seite besuchen"
};
